// import React,{Component} from "react";
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   CardTitle,
//   Row,
//   Col,
//   Button,
//   Table,
//   ModalHeader,
//   Input,
//   Modal,
//   Tooltip,
//   ListGroupItem,
//   ListGroup,
//   ModalBody,ModalFooter
// } from "reactstrap";
// // import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';
// import { arrayMove } from 'utils/arrayMove';
// import { Navigate } from "react-router-dom";
// import {store} from 'store/index';
// import { setAlert} from 'action/index.js';

// import ReadAloud from "components/Question/Mocks/Speaking/ReadAloud.jsx";
// import DescribeImage from "components/Question/Mocks/Speaking/DescribeImage.jsx";
// import RepeatSentece from "components/Question/Mocks/Speaking/RepeatSentece.jsx";
// import RetellLec from "components/Question/Mocks/Speaking/RetellLec.jsx";
// import ShortQue from "components/Question/Mocks/Speaking/ShortQue.jsx";

// import Summary from "components/Question/Mocks/Writting/Summary.jsx";
// import Essay from "components/Question/Mocks/Writting/Essay.jsx";

// import SingleAnswer from "components/Question/Mocks/Reading/SingleAnswer.jsx";
// import MultipleAnswer from "components/Question/Mocks/Reading/MultipleAnswer.jsx";
// import Reorder from "components/Question/Mocks/Reading/Reorder1.jsx";
// import ReadingBlank from "components/Question/Mocks/Reading/ReadingBlank.jsx";
// import WrittingBlank from "components/Question/Mocks/Reading/WrittingBlank.jsx";

// import Summer from "components/Question/Mocks/Listening/Summer.jsx";
// import McqSingle from "components/Question/Mocks/Listening/McqSingle.jsx";
// import McqMulti from "components/Question/Mocks/Listening/McqMulti.jsx";
// import ListeningBlank from "components/Question/Mocks/Listening/ListeningBlank.jsx";
// import MissingWord from "components/Question/Mocks/Listening/MissingWord.jsx";
// import CorrectSummary from "components/Question/Mocks/Listening/CorrectSummary.jsx";
// import Dictation from "components/Question/Mocks/Listening/Dictation.jsx";
// import Highlight from "components/Question/Mocks/Listening/Highlight.jsx";

// import ReactHtmlParser from 'react-html-parser';
// import "components/custom.css";
// // core components
// import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
// import API, {base,s3base} from "api.js";
// import Unauthorized from "components/Exceptions/Unauthorized";
// import TooltipItem from "components/ToolTip/ToolTipItem.jsx";
// import SidebarClose from "components/Sidebar/SidebarClose";
// import MoreAiSuggestions from "components/Result/More/MoreAiSuggestions";
// import RecordedWaveform from "components/Question/Speaking/RecordedWaveform";
// import FillInTheBlankExplanation from "components/PracticeMaterial/PopUps/FillInTheBlankExplanation";
// import TemplateDetectorModal from "components/PracticeMaterial/PopUps/TemplateDetectorModal";

// const SHOW_SAMPLE_RESPONSE = [7];
// class Result extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       questionData:false,
//       currentQuestion:0,
//       isRecording: false,
//       blobURL: '',
//       isBlocked: false,
//       type:'',
//       result:{},
//       second:0,
//       finalResult:[],
//       lastFlag:true,
//       resultData:'',
//       modal:false,
//       pending: false,
//       id:0,
//       scoreData:[],
//       mock_title:'',
//       reportModal:false,
//       comment:"",
//       reportText:"",
//       reportErr:"",
//       unauthorized: false,
//       isLoaded: false,
//       explanationModal:false,
//       option_explaination:{status:false},
//       paragraphExplainationModal:false,
//       templateDetectorModalProps:{}
//     };
//   }

//   componentWillUnmount() {
//     document.body.classList.toggle("sidebar-mini");
//     //document.querySelector('#minimizeSidebar').style.display = "block"
//   }
//   reportModalfunc = () =>{
//     this.setState({reportModal:!this.state.reportModal});
//   }

//   changeReportText = (e) => {
//     let { name, value } = e.target;
//     this.setState({ [name] : value });
//   }

//   componentDidMount() {
//     document.body.classList.toggle("sidebar-mini");
//     //document.querySelector('#minimizeSidebar').style.display = "none"
//     API({
//         method: 'GET',
//         url: 'mock/resultDetail/'+this.props.match.params.id
//       }).then(data => {
//         this.setState({ isLoaded: true });

//         if(
//           typeof data.data.message !== 'undefined' && 
//           typeof data.data.message !== undefined && 
//           data.data.message === 'unauthorized access'
//         ) {
//           this.setState({unauthorized: true});
//         }
//         //if (data.data.data.question.length != data.data.data.question_count ) {
//         //  this.setState({pending:false})
//         //}else{
//           this.setState({
//             mock_title: data.data.data.mock.title,
//             questionData: data.data.data.question,
//             type: data.data.data.question[0].question.subcategory_id
//           }, () => {
//             this.displayResult();
//           });        
//        // }
//         // var intervalId = setInterval(this.timer, 1000);        
//     }).catch(()=>{

//     });
//   }

//   timer = () => {
//     this.setState({second:this.state.second+1});
//   }

//     submitReport = () => {

//     if(this.state.reportText === ""){
//       this.setState({reportErr:"Message cant't be empty"});
//       store.dispatch(setAlert({'flag':true,'type':2,'message':"Message cant't be empty"}));
//       return ""
//     }
//     this.setState({reportErr:""});

//     var bodyFormData = new FormData();
//     bodyFormData.set('text', this.state.reportText);
//     bodyFormData.set('question_id', this.state.questionData[this.state.currentQuestion].question_id);
//     API({
//       method: 'POST',
//       data: bodyFormData,
//       url: 'report/question',
//     }).then(data => {
//       if (data.status === 200) {
//         this.setState({'reportText':'',reportModal:false});
//         store.dispatch(setAlert({'flag':true,'type':1,'message':data.data.message}));  
//       }

//     }).catch(()=>{

//     });  
//   }

//   getOpenAIExplaination = async(formData) => {
//     API({
//       method: 'POST',
//       url: `get-explanation`,
//       data: formData
//     }).then(res => {
//       this.setState({
//         option_explaination: res.data
//       });
//     });
//   };


//   displayResult = () => {
//     let q_data = this.state.questionData[this.state.currentQuestion];

//     if(q_data.type === 11 || q_data.type === 12) {
//       const correct = q_data.correct;
//       const corArray = correct?.split(',').map(item=>item.trim());
//       const selArray = q_data.answer?.split(',').map(item=>item.trim());
//       const selectedArray = corArray.map((item,index)=>(selArray?.[index] && selArray?.[index]!=='-')?selArray[index].trim():'__');

//       if ('explanation' in q_data && q_data.explanation.status) {
//         this.setState({
//           option_explaination: q_data.explanation
//         });
//       }
//       // this.getOpenAIExplaination({
//       //   type: q_data.type,
//       //   id: q_data.question_id,
//       //   selected:selectedArray.join(),
//       //   correct,
//       // });
//     }

//     let selected_arr = [];
//     let correct_arr = [];

//     switch(q_data.type) {
//       case 11:
//       if (q_data.answer) {
//         q_data.answer.split(',').map((v,k)=>{ 
//           if(v.trim() === q_data.correct.split(',')[k].trim()){
//             document.querySelectorAll('.selected-option')[k].innerHTML =  '<span className="right-blank">'+q_data.answer.split(',')[k]+'&nbsp; <i className="fa fa-check" style="font-size:16px;"></i></span>';
//           }else{
//             if (document.querySelectorAll('.selected-option').length > k) {
//               document.querySelectorAll('.selected-option')[k].innerHTML =  '<span className="wrong-blank">'+q_data.answer.split(',')[k]+'&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>';  
//             }

//           }
//         });
//       }else{
//         q_data.correct.split(',').map((v,k)=>{ 
//           document.querySelectorAll('.selected-option')[k].innerHTML =  '<span className="wrong-blank">&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>'
//         })
//       }


//         break;
//       case 10:
//       let elemArr = document.querySelectorAll('.list-group-item1');
//       for (var i = 0; i < elemArr.length; i++) {
//         elemArr[i].classList.add('cross');
//       }

//       if (q_data.answer) {
//         let correct = q_data.correct.split(',');
//         let answer = q_data.answer.split(',');
//         for (var i = 0; i < answer.length-1; i++) {
//           for (var j = 0; j < correct.length-1; j++) {
//             if (correct.length > i+1) {
//               if (answer[i]+'-'+answer[i+1] == correct[j]+'-'+correct[j+1] ) {
//                 elemArr[i].classList.remove('cross');

//               }
//             }
//           }
//         }
//       }




//         break;
//       case 16:
//         if (q_data.answer === "-") {
//           let allInput = document.querySelectorAll('.selected-option');
//           for (var i = 0; i < allInput.length; i++) {
//             allInput[i].innerHTML = '<span className="wrong-blank">&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>';
//           }
//         }else{
//           q_data.answer.split(',').map((v,k)=>{ 
//             if(v.trim() === q_data.correct.split(',')[k].trim()){
//               document.querySelectorAll('.selected-option')[k].innerHTML =  '<span className="right-blank">'+q_data.answer.split(',')[k]+'&nbsp; <i className="fa fa-check" style="font-size:16px;"></i></span>';  
//             }else{
//               if (document.querySelectorAll('.selected-option').length > k) {
//                 document.querySelectorAll('.selected-option')[k].innerHTML =  '<span className="wrong-blank">'+q_data.answer.split(',')[k]+'&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>'           
//               }


//             }
//           });  
//         }


//         break;
//       case 12:
//       if (q_data.answer) {
//         q_data.correct.split(',').map((v,k)=>{
//           document.querySelectorAll('.selected-option')[k].innerHTML =  '<span className="wrong-blank">&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>';  
//         })
//         q_data.answer.split(',').map((v,k)=>{ 
//           if(v.trim() === q_data.correct.split(',')[k].trim()){
//             document.querySelectorAll('.selected-option')[k].innerHTML =  '<span className="right-blank">'+q_data.answer.split(',')[k]+'&nbsp; <i className="fa fa-check" style="font-size:16px;"></i></span>';
//           }else{
//             if (document.querySelectorAll('.selected-option').length > k) {
//               document.querySelectorAll('.selected-option')[k].innerHTML =  '<span className="wrong-blank">'+q_data.answer.split(',')[k]+'&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>';
//             }
//           }
//         });
//       }else{
//         q_data.correct.split(',').map((v,k)=>{
//           document.querySelectorAll('.selected-option')[k].innerHTML =  '<span className="wrong-blank">&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>';  
//         })
//       }


//         break;
//       case 15:
//         this.changeColorReset();
//         //document.querySelectorAll('input').parentElement.parentElement.parentElement.style="background:white";    

//         correct_arr = [];
//         if (q_data.correct) {
//           correct_arr = q_data.correct.split(',').map(item => item.trim());
//         }
//         if (q_data.answer) {

//           selected_arr = q_data.answer.split(',').map(item => item.trim());
//           selected_arr.map((k)=> {
//             if (correct_arr.includes(k)) {
//               document.querySelector('input[value="'+k+'"]').parentElement.parentElement.parentElement.style="background:green";         
//             }else{
//               document.querySelector('input[value="'+k+'"]').parentElement.parentElement.parentElement.style="background:red";
//             }

//           });
//         }
//         let result = correct_arr.filter(x => !selected_arr.includes(x));
//         result.map((k)=>{
//           document.querySelector('input[value="'+k+'"]').parentElement.parentElement.parentElement.style="background:blue";
//         });
//         if(q_data.correct){
//             //document.querySelector('input[value="'+q_data.correct+'"]').parentElement.parentElement.parentElement.style="background:blue";         
//           }else{
//             let correct = q_data.question.option.filter((p) => {if(p && p.correct === 1) return p; } );
//             correct.map((p)=>{
//               document.querySelector('input[value="'+p.id+'"]').parentElement.parentElement.parentElement.style="background:blue";
//             });

//           }

//         break;
//       case 18:
//         this.changeColorReset();
//         if (q_data.answer != null && q_data.correct.trim() === q_data.answer.trim()) {
//             document.querySelector('input[value="'+q_data.answer+'"]').parentElement.parentElement.parentElement.style="background:green";
//         }else{
//           if (q_data.answer != null) {
//             document.querySelector('input[value="'+q_data.answer+'"]').parentElement.parentElement.parentElement.style="background:red";
//           }
//           document.querySelector('input[value="'+q_data.correct+'"]').parentElement.parentElement.parentElement.style="background:blue";
//         }
//         break;
//       case 17:
//         this.changeColorReset();
//         if (q_data.answer != null && q_data.correct.trim() === q_data.answer.trim()) {
//           document.querySelector('input[value="'+q_data.answer+'"]').parentElement.parentElement.parentElement.style="background:green";
//         }else{
//           if (q_data.answer != null) {
//             document.querySelector('input[value="'+q_data.answer+'"]').parentElement.parentElement.parentElement.style="background:red";
//           }
//           document.querySelector('input[value="'+q_data.correct+'"]').parentElement.parentElement.parentElement.style="background:blue";
//         }
//         break;
//       case 14:
//         this.changeColorReset();
//         if (q_data.answer && q_data.correct.trim() === q_data.answer.trim()) {
//           document.querySelector('input[value="'+q_data.answer+'"]').parentElement.parentElement.parentElement.style="background:green";
//         }else{
//           if (q_data.answer) {
//             document.querySelector('input[value="'+q_data.answer+'"]').parentElement.parentElement.parentElement.style="background:red";
//           }
//           if(q_data.correct){
//             document.querySelector('input[value="'+q_data.correct+'"]').parentElement.parentElement.parentElement.style="background:blue";
//           }else{
//             let correct = q_data.question.option.filter((p) => {if(p && p.correct === 1) return p; } );
//             document.querySelector('input[value="'+correct[0].id+'"]').parentElement.parentElement.parentElement.style="background:blue";
//           }
//         }
//         break;
//       case 8:
//         this.changeColorReset();
//         if (q_data.answer && q_data.answer != null && q_data.correct.trim() === q_data.answer.trim()) {
//           document.querySelector('input[value="'+q_data.answer+'"]').parentElement.parentElement.parentElement.style="background:green";
//         }else{
//           if (q_data.answer && q_data.answer != null) {
//             document.querySelector('input[value="'+q_data.answer+'"]').parentElement.parentElement.parentElement.style="background:red";
//           }
//           if(q_data.correct){
//             document.querySelector('input[value="'+q_data.correct+'"]').parentElement.parentElement.parentElement.style="background:blue";
//           }else{
//             let correct = q_data.question.option.filter((p) => {if(p && p.correct === 1) return p; } );
//             document.querySelector('input[value="'+correct[0].id+'"]').parentElement.parentElement.parentElement.style="background:blue";
//           }

//         }
//         break;
//       case 9:
//         this.changeColorReset();
//         correct_arr = [];
//         if (q_data.correct) {
//           correct_arr = q_data.correct.split(',').map(item => item.trim());
//         }
//         if (q_data.answer) {
//             selected_arr = q_data.answer.split(',').map(item => item.trim());
//             selected_arr.map((k)=> {

//               if (correct_arr.includes(k)) {
//                 if (document.querySelector('input[value="'+k+'"]')) {
//                     document.querySelector('input[value="'+k+'"]').parentElement.parentElement.parentElement.style="background:green";         
//                 }

//               }else{
//                 if (document.querySelector('input[value="'+k+'"]')) {
//                   document.querySelector('input[value="'+k+'"]').parentElement.parentElement.parentElement.style="background:red";  
//                 }
//               }
//             });

//         }
//         let result1 = correct_arr.filter(x => !selected_arr.includes(x));
//         result1.map((k)=>{
//           if (document.querySelector('input[value="'+k+'"]')) {
//             document.querySelector('input[value="'+k+'"]').parentElement.parentElement.parentElement.style="background:blue";         
//           }

//         });
//         if(!q_data.correct){
//             let correct = q_data.question.option.filter((p) => {if(p && p.correct === 1) return p; } );
//             correct.map((p)=>{
//               document.querySelector('input[value="'+p.id+'"]').parentElement.parentElement.parentElement.style="background:blue";
//             });

//           }

//         break;
//       case 19:
//         if (this.state.questionData.length > 0) {
//           document.querySelector('.result-correct').innerHTML = this.state.questionData[this.state.currentQuestion].html;
//         }
//         //document.querySelector('.result-correct').innerHTML = "";//this.state.questionData[this.state.currentQuestion].html;      

//       let elem = document.querySelectorAll('.result-correct span');
//       for (var i = 0; i < elem.length; i++) {
//           let hig = document.querySelectorAll('.result-correct span')[i].classList.value;
//           let higText = document.querySelectorAll('.result-correct span')[i].textContent;
//           if (hig == "correct hidd") {
//             document.querySelectorAll('.result-correct span')[i-1].style = "background:blue;color:white";     
//           }
//       }
//       for (var i = 0; i < elem.length; i++) {
//           let hig = document.querySelectorAll('.result-correct span')[i].classList.value;
//           let higText = document.querySelectorAll('.result-correct span')[i].textContent;
//           let corr = "";
//           if (elem.length > (i+1)) {
//             corr = document.querySelectorAll('.result-correct span')[i+1].classList.value;    
//           }
//         if (hig == "highlight1") {
//             if (corr == "correct hidd") {
//               document.querySelectorAll('.result-correct span')[i].innerHTML = higText+'&nbsp; <i className="fa fa-check" style="font-size:16px;"></i></span>';     
//               document.querySelectorAll('.result-correct span')[i].style = "background:green";     
//             }else{
//             document.querySelectorAll('.result-correct span')[i].innerHTML = higText+'&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>';
//             document.querySelectorAll('.result-correct span')[i].style = "background:red";
//           }

//         }

//       }

//       break;
//       default:

//     }
//   };

//   changeColorReset = () => {
//     let allInput = document.querySelectorAll('input');
//     for (var i = 0; i < allInput.length; i++) {
//       allInput[i].parentElement.parentElement.parentElement.style="background:white;color:black !important;";
//     }
//   };
//   showQuestion(type) {
//     return <Navigate to={"/practice/"+type} replace />;
//   }
//   submitResponse = (data) => {

//   }
//   showScore = (e,id) =>{
//     let {
//       type,template_type, template_issue, common_sentence, score, no_of_repeat_allowed
//     } = this.state.questionData[this.state.currentQuestion];

//     if([3,4].includes(type,template_type) && ["repeat","common"].includes(template_type) && (template_issue!=''|| common_sentence!= '')) {
//       this.setState({
//         templateDetectorModalProps: {
//           title:
//             template_type === "repeat"
//               ? template_issue
//               : template_type === "common"
//               ? common_sentence
//               : "",
//           template_type: template_type,
//           common_sentence: common_sentence,
//           data: {remarks: score[0].remarks,
//             no_of_repeat_allowed,
//             overallScore:{score: ((score[0].score + score[1].score + score[2].score)/3), out_of:score[0].from},
//             contentScore: {score: score[0].score, out_of:score[0].from},
//             fluencyScore: {score: score[1].score, out_of:score[1].from},
//             pronunciationScore: {score: score[2].score, out_of:score[2].from},
//         }},
//         explanationModal:true
//       });
//     } else {
//       this.setState({
//         modal: !this.state.modal,
//         id
//       });
//     }
//   }

//   closeModalExplanation = () => {
//     this.setState({explanationModal:false});
//   }

//   toggle = () =>{
//     this.setState({modal:!this.state.modal});
//   }

//   showHistoryFunc = () =>{
//     let id = this.state.questionData[this.state.currentQuestion].id;
//     let arr = this.state.questionData.map((v) => { if (id === v.id) {return v.score}  });
//     let arr1 =arr.filter((va)=> {if(typeof va === "object"){ return va;}})[0]
//     let a =  arr1.map( (v) =>{ return(`<tr><td>${this.remarks(v.type)}</td><td>${v.score}/${v.from}</td><td>${v.remarks}</td></tr>` )} );
//     if ([6,7,13].includes(this.state.questionData[this.state.currentQuestion].type)) {
//       let t_from = 0;
//       let t_score = 0;
//       for (var i = 0; i <= arr1.length-1; i++) {
//         t_from += arr1[i].from;
//         t_score += arr1[i].score;
//       }
//       a.push('<tr><td>Total</td><td colspan="2">'+t_score+'/'+t_from+'</td></tr>')
//     }
//     return a;
//   }
//   remarks = (type) => {
//     let str="";
//     switch(type) {
//       case 0:
//         str ="Content";
//         break;
//       case 1:
//         str ="Fluency";
//         break;
//       case 2:
//         str ="Pronunciation";
//         break;
//       case 3:
//         str ="Score";
//         break;
//       case 4:
//         str ="Grammar";
//         break;
//       case 5:
//         str ="Form";
//         break;
//       case 6:
//         str ="Vocabulary";
//         break;
//       case 7:
//         str ="Spelling";
//         break;
//       case 8:
//         str ="Linguistic range";
//         break;
//       case 9:
//         str ="Structure";
//         break;
//       default:
//         str = "";
//     }
//     return str;    
//   }
//   resultStatus = () => {
//     this.setState({is_result:true});

//   }

//   soundChecked = () => {}
//   stopRecording = () => {}
//   nextQuestion = ()=>{}

//   changeQuestion = (e, k) => {
//     let question = this.state.questionData[k];
//     let state_obj = {
//       result: {},
//       currentQuestion: k,
//       type: question.question.subcategory_id
//     };
//     if ('explanation' in question) {
//       state_obj.option_explaination = question.explanation;
//     }

//     this.setState(state_obj, () => {
//       this.displayResult();
//     });

//     this.forceUpdate();
//   }



//   nextButton = () => {
//     let question = this.state.questionData[this.state.currentQuestion+1];
//     let state_obj = {
//       result: {},
//       currentQuestion: this.state.currentQuestion + 1,
//       type: question.question.subcategory_id
//     };
//     if ('explanation' in question) {
//       state_obj.option_explaination = question.explanation;
//     }

//     this.setState(state_obj, ()=>{
//       this.displayResult();
//     });
//     this.forceUpdate();
//   }

//   prevButton = () => {
//     let question = this.state.questionData[this.state.currentQuestion-1];
//     let state_obj = {
//       result: {},
//       currentQuestion: this.state.currentQuestion - 1,
//       type: question.question.subcategory_id
//     };

//     if ('explanation' in question) {
//       state_obj.option_explaination = question.explanation;
//     }

//     this.setState(state_obj, () => {
//       this.displayResult();
//     });

//     this.forceUpdate();
//   }

//   finalSubmit = () =>{

//   }

//   renderResponse = (html) => {

//     // return "true";
//     // const items = typeof html === 'string' ? JSON.parse(html) : html;
//     // const items = html.charAt(0) === '<' ? html : JSON.parse(html);
//     let items = [];
//     if(html.charAt(0) === '<'){
//       return ReactHtmlParser(html)
//     } else {
//       items = JSON.parse(html);
//     }

//     return (
//       <>
//         {
//           items.map((item, i) => {
//             if (this.state.questionData[0].subcategory_id === 5) {
//               return (
//                 <>
//                   <span>Your Response: </span><span className={item.class} key={i}>{item.word !== "&nbsp;" ? item.word : " "}</span>
//                 </>
//               );
//             } else {
//               return <TooltipItem key={i} item={item} id={i} />;
//             }
//           })
//         }
//       </>
//     );
//   }

//   showExplanation = () => {
//     this.setState({paragraphExplainationModal:true});
//   }

//   toggleModal = () => {
//     this.setState((prevState) => ({ paragraphExplainationModal: !prevState.paragraphExplainationModal }));
//   };


//   showParagraphExplanationButton = () => {
//     if ([11, 12].includes(parseInt(this.state.type))) {
//       let question = this.state.questionData[this.state.currentQuestion];
//       if ('explanation' in question && 'paragraph_explanation' in question.explanation) {
//         return true;
//       }
//     }
//     return false;
//   }


//   render() {
//     let que;
//     let val;
//     let topbar = false;
//     let props ={};
//     if (this.state.questionData) {
//       props = {
//         submit: this.submitResponse,
//         showResult: this.resultStatus,
//         data: this.state.questionData[this.state.currentQuestion].question,
//         answer: true,
//         resultMode: true,
//         testMode: false,
//         soundChecked: this.soundChecked,
//         stopRecording: this.state.stopRecording,
//         nextQuestion: this.state.nextQuestion
//       };  
//       val = this.state.questionData[this.state.currentQuestion];
//     }
//     let title = "";
//     let ques_title = "";
//     if (this.state.questionData.length >0) {
//       ques_title = this.state.questionData[this.state.currentQuestion].q_title;
//     }


//     switch(this.state.type) {
//       case 1:
//         que = <ReadAloud {...props} key={this.state.currentQuestion} />;
//         title = "Look at the text below. In the 35 seconds, you must read this text aloud as naturally and clearly as possible. You have 35 seconds to read aloud.";
//         break;
//       case 2:
//         que = <RepeatSentece {...props} key={this.state.currentQuestion} />;
//         title = "You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.";
//         break;
//       case 3:
//         que = <DescribeImage {...props} key={this.state.currentQuestion} />;
//         title = "Look at the Image below. In 25 seconds,please speak into the microphone and describe in detail what the graph showing. You will have 40 seconds to give your response.";
//         break;
//       case 4:
//         que = <RetellLec {...props} key={this.state.currentQuestion} />;
//         title = "You will hear a lecture. After listening to the lecture, in 10 seconds, please speak into the microphone and retell what you have just heard from the lecture in your own words. You will have 40 seconds to give your response.";
//         break;
//       case 5:
//         que = <ShortQue {...props} key={this.state.currentQuestion} />;
//         title = "You will hear a question. Please give a simple and short answer. Often just one or a few words is enough.";
//         break;
//       case 6:
//         que = <Summary {...props} key={this.state.currentQuestion} />;
//         title = "Read the passage and summarize it using one sentence. Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. your response will be judge on the quality of your writing and on how well your response presents the key points in the passage.";
//         break;
//       case 7:
//         que = <Essay {...props} key={this.state.currentQuestion} />;
//         title = "You will have 20 minutes to plan, write and revise an essay about the topic below. your response will be judged on how well you develop a position, oraganize your ideas, present supporting details, and control the elements of standard written English. You should write 200-300 words.";
//         break;
//       case 8:
//         topbar = true;
//         que = <SingleAnswer {...props} key={this.state.currentQuestion} />;
//         title = "Read the text and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
//         break;
//       case 9:
//         topbar = true;
//         que = <MultipleAnswer {...props} key={this.state.currentQuestion} />;
//         title = "Read the text and answer the question by selecting all the correct responses. More than one response is correct.";
//         break;
//       case 10:
//         que = <Reorder {...props} key={this.state.currentQuestion} />;
//         title = "The textbox in the left panel have been placed in a random order. Restore the original order by dragging the text boxes from the left panel to the right panel.";
//         break;
//       case 11:
//         topbar = true;
//         que = <ReadingBlank {...props} option_explaination={this.state.option_explaination} quen={this.state.questionData[this.state.currentQuestion]} key={this.state.currentQuestion} />;
//         title = "In the text below some words are missing. Drag words from the text box below to the appropriate place in the text. To undo an answer choice, drag the word back to the box below the text.";
//         break;
//       case 12:
//         topbar = true;
//         que = <WrittingBlank {...props}  option_explaination={this.state.option_explaination} quen={this.state.questionData[this.state.currentQuestion]} key={this.state.currentQuestion} />;
//         title = "Below is a text with blanks. Click on each blank, a list of choices will appear. Select the appropriate answer choice for each blank.";
//         break;
//       case 13:
//         que = <Summer {...props} key={this.state.currentQuestion} />;
//         title = "You will hear a short lecture. Write a summary for a fellow student who was not present at the lecture. You should write 50-70 words. You have 10 minutes to finish the task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the lecture.";
//         break;
//       case 14:
//         topbar = true;
//         que = <McqSingle {...props} key={this.state.currentQuestion} />;
//         title = "Listen to the recording and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
//         break;
//       case 15:
//         topbar = true;
//         que = <McqMulti {...props} key={this.state.currentQuestion} />;
//         title = "Listen to the recording and answer the question by selecting all the correct responses. You will need to select more than one response.";
//         break;
//       case 16:
//         topbar = true;
//         que = <ListeningBlank {...props} key={this.state.currentQuestion} />;
//         title = "You will hear a recording. Type the missing words in each blank.";
//         break;
//       case 17:
//         topbar = true;
//         que = <CorrectSummary {...props} key={this.state.currentQuestion} />;
//         title = "You will hear a recording. Click on the paragraph that best relates to the recording.";
//         break;
//       case 18:
//         topbar = true;
//         que = <MissingWord {...props} key={this.state.currentQuestion} />;
//         title = "You will hear a recording about "+ ques_title+". At the end of the recording the last word or group of words has benn replaced by a beep. Select the correct option to complete the recording";
//         break;
//       case 19:
//         topbar = true;
//         que = <Highlight {...props} key={this.state.currentQuestion} />;
//         title = "You will hear a recording. Below is a transcription of the recording. Some words in the transcription differ from what the speaker(s) said. Please click on the words that are different.";
//         break;
//       case 20:
//         que = <Dictation {...props} key={this.state.currentQuestion} />;
//         title = "You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once.";
//         break;
//       default:
//         // code block
//     }


//     return (
//       <>
//         {!this.state.isLoaded ? (
//           <></>
//         ) : (
//           <>
//             {!this.state.unauthorized ? (
//               <>
//                 {this.state.reportModal &&
//                   <Modal isOpen={this.state.reportModal} size="lg">
//                     <ModalBody>
//                       <ModalHeader>Report the problem in this question </ModalHeader>
//                       <span className="text-danger">{this.state.reportErr}</span>
//                       <Input type="textarea" value={this.state.reportText} name="reportText" onChange={(e)=>{this.changeReportText(e);}} />
//                     </ModalBody>
//                     <ModalFooter>
//                       <Button color="secondary" className="modalCloseBtn" onClick={this.submitReport}>Submit</Button>
//                       <Button color="secondary" className="modalCloseBtn" onClick={this.reportModalfunc}>Close</Button>
//                     </ModalFooter>
//                   </Modal>
//                 }

//                 {this.state.modal &&
//                   <Modal isOpen={this.state.modal} size="lg">
//                     <div className="modalHeader">
//                       <h2></h2>
//                     </div>
//                     <ModalBody>
//                       <Table>
//                         <thead>
//                           <tr>
//                             <th>Component</th>
//                             <th>Score</th>
//                             <th>Remarks</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {this.showHistoryFunc().map((v) => {
//                             return (ReactHtmlParser(v))
//                           })}
//                         </tbody>
//                       </Table>
//                     </ModalBody>
//                     <ModalFooter>
//                       <Button color="secondary" className="modalCloseBtn" onClick={this.toggle}>Close</Button>
//                     </ModalFooter>
//                   </Modal>
//                 }

//                 <div className="content questionsArea old-design">
//                   {/*<SidebarClose />*/}
//                   <Row>
//                     <Col xs={12}>
//                       <Card>
//                         {!this.state.pending &&
//                           <CardBody>
//                             {topbar &&
//                               <div className="row infoBars">
//                                 <div className="col-sm-3 wrongAns">
//                                   <i className="fa fa-times" aria-hidden="true"></i> <span>Your selected & wrong answer</span>
//                                 </div>
//                                 <div className="col-sm-3 correctAns">
//                                   <i className="fa fa-check" aria-hidden="true"></i> <span>Your selected & correct answer</span>
//                                 </div>
//                                 <div className="col-sm-3 notSelected">
//                                   <i className="fa fa-check" aria-hidden="true"></i> <span>Not selected & correct answer</span>
//                                 </div>
//                               </div>
//                             }

//                             <div className="row">
//                               <div className="col-sm-10">
//                                 <h4 className="mt-0">{this.state.mock_title}</h4>
//                                 <h6>{title}</h6>
//                                 <Row className='unselectable'> 
//                                   { !this.state.pending && this.state.questionData && que }
//                                   {[13,19].includes(this.state.type) &&
//                                     <div>
//                                       <h3>Audio Script</h3>
//                                       <h4>{ReactHtmlParser(val.question.audio_script)}</h4>
//                                     </div>
//                                   }
//                                 </Row>

//                                 <div className="result-div old-design-result">
//                                   {[2,4,5,15,19,14,16,18,17,13,20].includes(this.state.type) &&
//                                     <div>
//                                       <h3> Question Audio - </h3> <audio src={s3base+val.question.media_link} controls="controls" controlsList="nodownload" />
//                                     </div>
//                                   }
//                                   {[6,7,13].includes(this.state.type) &&
//                                     <div>
//                                       <h3>Your Response</h3>
//                                       <h5>{ReactHtmlParser(val.answer)}</h5>
//                                       {[6,7,13].includes(this.state.type) &&
//                                         <div><h3>Word count: {val.correct}</h3></div>
//                                       }
//                                     </div>
//                                   }
//                                   {[11,12,16].includes(this.state.type) &&
//                                     <div>
//                                       {false && <h3>Your Response</h3>}
//                                       {false && val.answer.split(',').map((v,k)=>{
//                                         if(k > val.correct.length && v.trim() === val.correct.split(',')[k].trim()){
//                                           return ReactHtmlParser('<span>'+v+'<span><i className="fa fa-check" style="font-size:32px;color:green"></i></span></span>');
//                                         }else{
//                                           console.log(v)
//                                           console.log(val.correct.split(',')[k])
//                                           return ReactHtmlParser('<span>'+v+'<span><i className="fa fa-times" style="font-size:32px;color:red"></i></span></span>');
//                                         }
//                                       })}
//                                     </div>
//                                   }
//                                   {[19].includes(this.state.type) &&
//                                     <div>
//                                       <h3>Your Response</h3>
//                                       {<span className="result-correct"></span>}
//                                     </div>
//                                   }
//                                   {[20].includes(this.state.type) &&
//                                     <div>
//                                       <h3>Correct Answer</h3>
//                                       <h5 className="text-success">{ReactHtmlParser(val.question.audio_script)}</h5>
//                                     </div>
//                                   }

//                                   {[8,9,14,15,17,18,20].includes(this.state.type) &&
//                                     <div>
//                                       <h3>Your Response</h3>
//                                       <h5>{ReactHtmlParser(val.html)}</h5>
//                                     </div>
//                                   }
//                                   {[14,15,16,17,18,19,20].includes(this.state.type) &&
//                                     <div>
//                                       <h5 className="text-danger">{(val.answer)?"":"(Not Attempted)"}</h5>
//                                     </div>
//                                   }
//                                   {[10].includes(this.state.type) &&
//                                     <div className="row">
//                                       <div className="col-md-6">
//                                         <h3>Correct order</h3>
//                                         {que}
//                                       </div>
//                                       <div className="col-md-6">
//                                         <h3>Your Response</h3>
//                                         <div className="col-12"><h4 className="infoText"></h4></div><div className="col-12"><h5></h5></div><div className="col-12"><h3 className="question"></h3></div><div className="col-lg-12">&nbsp;</div><div className="col-lg-12"></div><div className="col-lg-12">&nbsp;</div>
//                                         <ul className="connectList">
//                                           {val.html.split('<br />').filter((va)=> {if(va !== ""){ return va;}}).map((v)=>{ return ReactHtmlParser('<li className="list-group-item1">'+v+'</li>')  })}
//                                         </ul>
//                                       </div>
//                                     </div>
//                                   }
//                                   {[1,2].includes(this.state.type) &&
//                                     <div>
//                                       <h3>Your Response</h3>
//                                       <h5><audio src={s3base + '/ptedata/ptemedia/' +val.file} controls="controls" /></h5>
//                                       {/* <RecordedWaveform
//                                       testMode={true}
//                                        blobURL={s3base + '/ptedata/ptemedia/' + val.file}
//                                        className="recorded-waveform-container-mock"
//                                       /> */}
//                                       {/*<h5>{(val.html !== null) ? ReactHtmlParser(val.html) : ""}</h5>*/}
//                                       <h5>{(val.html !== null) ? this.renderResponse(val.html) : ""}</h5>
//                                       <div>
//                                         <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW" >
//                                           <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
//                                             <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd" ></div>
//                                             Good
//                                           </div>
//                                           <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
//                                             <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJav"></div>
//                                             Average
//                                           </div>
//                                           <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
//                                             <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJbad"></div>
//                                             Bad pronunciation/Missed words
//                                           </div>
//                                           <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca"></div></div>
//                                       </div>
//                                     </div>
//                                   }
//                                   {[3,4].includes(this.state.type) &&
//                                     <div>
//                                       <h3>Your Response</h3>
//                                       <h5><audio src={s3base + '/ptedata/ptemedia/' +val.file} controls="controls" /></h5>
//                                       {/* <RecordedWaveform
//                                       testMode={false}
//                                        blobURL={s3base + '/ptedata/ptemedia/' +val.file}
//                                        className="recorded-waveform-container-mock"
//                                       /> */}
//                                       {/*<h5>{(val.html !== null) ? ReactHtmlParser(val.html) : ""}</h5>*/}
//                                       <h5>{(val.html !== null) ? this.renderResponse(val.html) : ""}</h5>
//                                       <div>
//                                         <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW" >
//                                           <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
//                                             <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd" ></div>Good
//                                           </div>
//                                           <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
//                                             <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJav"></div>Average
//                                           </div>
//                                         </div>
//                                       </div>
//                                     </div>
//                                   }
//                                   {[5].includes(this.state.type) &&
//                                     <div>
//                                       <h3>Your Response</h3>
//                                       <h5><audio src={s3base + '/ptedata/ptemedia/' +val.file} controls="controls" /></h5>
//                                       {/* <RecordedWaveform
//                                       testMode={false}
//                                        blobURL={s3base + '/ptedata/ptemedia/' +val.file}
//                                        className="recorded-waveform-container-mock"
//                                       /> */}
//                                       <h5>Your response: {ReactHtmlParser(val.html)}</h5>
//                                       <h5>Correct answer: {val.question.answer}</h5>
//                                     </div>
//                                   }

//                                   {this.showParagraphExplanationButton() &&
//                                     <div>
//                                       <Button
//                                         color="primary"
//                                         className="viewResultbtn"
//                                         onClick={(e) => this.showExplanation()}
//                                         size="sm"
//                                       >
//                                         Full Paragraph Explanation
//                                       </Button>
//                                     </div>
//                                   }

//                                   {this.state.questionData &&
//                                     <Button color="primary" className="viewResultbtn" onClick={(e) => this.showScore(e,this.state.questionData.id)} size="sm">View Score with Remarks</Button>
//                                   }
//                                 </div>
//                                 <div className="bottomBtn mt-5">
//                                   {SHOW_SAMPLE_RESPONSE.includes(this.state.type) &&
//                                     <Row>
//                                       <MoreAiSuggestions
//                                         question_id={this.state.questionData[this.state.currentQuestion].question.id}
//                                       />
//                                     </Row>
//                                   }
//                                 </div>
//                               </div>
//                               <div className="col-sm-2 speakingBar p-0">
//                                 <h4><i className="" aria-hidden="true"></i></h4>
//                                 <div className="topArrow">

//                                 </div>
//                                 <div className="numbersList unselectable">
//                                   {this.state.questionData && this.state.questionData.map((v,k)=>{
//                                     return <span onClick={(e) => this.changeQuestion(e, k)} className={(this.state.currentQuestion == k)?'selected-index-result cursor-pointer':'cursor-pointer'} key={k}>{(k+1)}</span>;
//                                   })}
//                                 </div>
//                                 <div className="nextPrev unselectable">
//                                   { (this.state.currentQuestion !== 0) && this.state.questionData.length!==0 && 
//                                     <a onClick={this.prevButton} className="prev cursor-pointer"><i className="fa fa-chevron-circle-left" aria-hidden="true"></i> Prev </a>
//                                   }
//                                   { (this.state.questionData.length != (this.state.currentQuestion+1)) && this.state.questionData.length!==0 &&
//                                     <a onClick={this.nextButton} className="next cursor-pointer">Next <i className="fa fa-chevron-circle-right" aria-hidden="true"></i></a>
//                                   }
//                                 </div>
//                                 <div className="quesStatus">
//                                   {/* <div className="atmptd">
//                                     <span>Attempted</span>
//                                   </div>
//                                   <div className="notAatmptd">
//                                     <span>Not Attempted</span>
//                                   </div>
//                                   <div className="currentQues">
//                                     <span>Current Question</span>
//                                   </div> */}
//                                 </div>
//                                 <div className="bottomBtn text-center"></div>
//                               </div>
//                             </div>
//                           </CardBody>
//                         }
//                         {this.state.pending &&
//                           <CardBody>
//                           	<div className="scoreContent text-center">
//                           		<div className="scoreLoading">
//                           			<img src="https://gifimage.net/wp-content/uploads/2017/08/loading-gif-transparent-4.gif" />
//                           		</div>
//                           		<div className="scoreInfo">
//           	                		<h4>AI Scoring Ongoing</h4>
//           	                		<p>Takes around 5 - 10 minutes<br />You can check back later</p>
//                           		</div>
//                           	</div>
//                           </CardBody>
//                         }
//                       </Card>
//                     </Col>

//                     {this.state.paragraphExplainationModal &&
//                       <FillInTheBlankExplanation
//                         isOpen={this.state.paragraphExplainationModal}
//                         title="Paragraph Explanation"
//                         data={this.state.option_explaination?this.state.option_explaination.paragraph_explanation:"Fetching Explanation..."}
//                         keyName={'paragraph_explanation'}
//                         closeModal={this.toggleModal}
//                       />
//                     }


//                     {!this.state.pending &&
//                       <Col xs={12}>
//                         <div className="">
//                           { (this.state.questionData.length != (this.state.currentQuestion+1)) && this.state.questionData.length!==0 &&
//                             <Button className="pull-right" color="primary" onClick={this.nextButton} size="lg">NEXT</Button>
//                           }
//                           { (this.state.currentQuestion !== 0) && this.state.questionData.length!==0 &&
//                             <Button className="pull-right" color="primary" onClick={this.prevButton} size="lg">PREVIOUS</Button>
//                           }
//                           {this.state.questionData.length !== 0 &&
//                             <Button
//                               color="info"
//                               className="bottom-btn"
//                               onClick={this.reportModalfunc}
//                               disabled={false}
//                               size="sm"
//                             >Report Question</Button>
//                           }
//                         </div>
//                       </Col>
//                     }
//                   </Row>
//                 </div>
//               </>) : <Unauthorized />
//             }
//           </>
//         )}

//         {this.state.explanationModal &&
//           <TemplateDetectorModal
//             isOpen={this.state.explanationModal}
//             {...this.state.templateDetectorModalProps}
//             data={this.state.templateDetectorModalProps.data}
//             closeModal={this.closeModalExplanation}
//           />
//         }
//       </>
//     );
//   }
// }
// export default Result;


import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button, Card, Row, Col } from "react-bootstrap";
import LaLoader from "components/Loader/LaLoader";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
// import { arrayMove } from 'utils/arrayMove';
import { Navigate, useParams } from "react-router-dom";
import { store } from 'store/index';
import { setAlert } from 'action/index.js';

import ReadAloud from "components/Question/Mocks/Speaking/ReadAloud.jsx";
import DescribeImage from "components/Question/Mocks/Speaking/DescribeImage.jsx";
import RepeatSentece from "components/Question/Mocks/Speaking/RepeatSentece.jsx";
import RetellLec from "components/Question/Mocks/Speaking/RetellLec.jsx";
import ShortQue from "components/Question/Mocks/Speaking/ShortQue.jsx";

import Summary from "components/Question/Mocks/Writting/Summary.jsx";
import Essay from "components/Question/Mocks/Writting/Essay.jsx";

import SingleAnswer from "components/Question/Mocks/Reading/SingleAnswer.jsx";
import MultipleAnswer from "components/Question/Mocks/Reading/MultipleAnswer.jsx";
import Reorder from "components/Question/Mocks/Reading/Reorder1.jsx";
import ReadingBlank from "components/Question/Mocks/Reading/ReadingBlank.jsx";
import WrittingBlank from "components/Question/Mocks/Reading/WrittingBlank.jsx";

import Summer from "components/Question/Mocks/Listening/Summer.jsx";
import McqSingle from "components/Question/Mocks/Listening/McqSingle.jsx";
import McqMulti from "components/Question/Mocks/Listening/McqMulti.jsx";
import ListeningBlank from "components/Question/Mocks/Listening/ListeningBlank.jsx";
import MissingWord from "components/Question/Mocks/Listening/MissingWord.jsx";
import CorrectSummary from "components/Question/Mocks/Listening/CorrectSummary.jsx";
import Dictation from "components/Question/Mocks/Listening/Dictation.jsx";
import Highlight from "components/Question/Mocks/Listening/Highlight.jsx";

import ReactHtmlParser from 'react-html-parser';
import reactStringReplace from "react-string-replace";
import "components/custom.css";
// import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import API, { base, s3base } from "api.js";
import Unauthorized from "components/Exceptions/Unauthorized";
import TooltipItem from "components/ToolTip/ToolTipItem.jsx";
// import SidebarClose from "components/Sidebar/SidebarClose";
import MoreAiSuggestions from "components/Result/More/MoreAiSuggestions";
// import RecordedWaveform from "components/Question/Speaking/RecordedWaveform";
import WaveformAudioPlayer from "components/Question/Speaking/WaveformAudioPlayer";
import FillInTheBlankExplanation from "components/PracticeMaterial/PopUps/FillInTheBlankExplanation";
import TemplateDetectorModal from "components/PracticeMaterial/PopUps/TemplateDetectorModal";
import SummarizeGroupDiscussion from "components/Question/Mocks/Speaking/SummarizeGroupDiscussion";
import RespondToSituation from "components/Question/Mocks/Speaking/RespondToSituation";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import Microphone from "/public/images/microphone.png";
import TickCircle from "/public/images/tick-circle.png";
import Content from "/public/images/popup-icons/Content.png";
import Pronunciation from "/public/images/popup-icons/pronoun.png";
import Fluency from "/public/images/popup-icons/checkboxGreen.png";
import BarFrequency from "/public/images/popup-icons/popupBar.png";
import Grammar from "/public/images/popup-icons/Grammar.png";
import Vocabulary from "/public/images/popup-icons/Vocabulary.png";
import FormIcon from "/public/images/popup-icons/Form.png";
import linguistic from "/public/images/popup-icons/linguistic-icon.png";
import Structure from "/public/images/popup-icons/structure-icon.png";
import ScoreIcon from "/public/images/popup-icons/Score-icon.png";
import { Checkbox } from '@mui/material';

const SHOW_SAMPLE_RESPONSE = [7];

const Result = ({ match }) => {
  const [state, setState] = useState({
    questionData: false,
    currentQuestion: 0,
    isRecording: false,
    blobURL: '',
    isBlocked: false,
    type: '',
    result: {},
    second: 0,
    finalResult: [],
    lastFlag: true,
    resultData: '',
    modal: false,
    pending: false,
    id: 0,
    scoreData: [],
    mock_title: '',
    reportModal: false,
    comment: "",
    reportText: "",
    reportErr: "",
    isSubmittingReport: false,
    unauthorized: false,
    isLoaded: false,
    explanationModal: false,
    explanationModalWriting: false,
    option_explaination: { status: false },
    paragraphExplainationModal: false,
    templateDetectorModalProps: {},
    selectedArray : [],
    correctArray : [],
    average_score: 0,
    speed_percentage:null
  });

  let que;
  let val;
  let topbar = false;
  let props = {};
  const { id } = useParams();
  const [answer_explaination_key, setAnswerExplainationKey] = useState("");

  useEffect(() => {
    if (!id) {
      console.log("no id present");
      setState(prevState => ({ ...prevState, unauthorized: true }));
      return;
    }
    document.body.classList.toggle("sidebar-mini");
    API({
      method: 'GET',
      url: 'mock/resultDetail/' + id
    }).then(data => {
      setState(prevState => ({
        ...prevState,
        isLoaded: true,
        unauthorized: data.data.message === 'unauthorized access',
        mock_title: data.data.data.mock.title,
        questionData: data.data.data.question,
        type: data.data.data.question[0].question.subcategory_id,
        average_score: data.data.data.average_score,
        speed_percentage:data.data.data.question[state.currentQuestion].speed_percentage
      }));
    }).catch(() => { });

    return () => {
      document.body.classList.toggle("sidebar-mini");
    };
  }, []);

  // console.log({ match });

  useEffect(() => {
  if (state.questionData && state.questionData.length > 0) {
   requestAnimationFrame(displayResult);
  }
}, [state.currentQuestion, state.questionData]);

  const reportModalfunc = () => {
    setState(prevState => ({ ...prevState, reportModal: !prevState.reportModal, reportText: '' }));
  };

  const changeReportText = (e) => {
    let { name, value } = e.target;
    setState(prevState => ({ ...prevState, [name]: value }));
  };

  const submitReport = () => {
    if (state.isSubmittingReport) return;

    if (state.reportText === "") {
      setState(prevState => ({ ...prevState, reportErr: "Message can't be empty" }));
      store.dispatch(setAlert({ 'flag': true, 'type': 2, 'message': "Message can't be empty" }));
      return "";
    }
    setState(prevState => ({ ...prevState, reportErr: "", isSubmittingReport: true }));

    var bodyFormData = new FormData();
    bodyFormData.set('text', state.reportText);
    bodyFormData.set('question_id', state.questionData[state.currentQuestion].question_id);
    API({
      method: 'POST',
      data: bodyFormData,
      url: 'report/question',
    }).then(data => {
      if (data.status === 200) {
        store.dispatch(setAlert({ 'flag': true, 'type': 1, 'message': data.data.message }));
         setState(prevState => ({ ...prevState, reportText: '', reportModal: false, isSubmittingReport: false }));
      }else{
         setState(prevState => ({ ...prevState, isSubmittingReport: false }));
      }
    }).catch(() => {
      setState(prevState => ({ ...prevState, isSubmittingReport: false }));
    });
  };

  const getOpenAIExplaination = async (formData) => {
    API({
      method: 'POST',
      url: `get-explanation`,
      data: formData
    }).then(res => {
      setState(prevState => ({ ...prevState, option_explaination: res.data }));
    });
  };

   const changeColorReset = () => {
    let allInput = document.querySelectorAll('input');
    for (var i = 0; i < allInput.length; i++) {
      allInput[i].parentElement.parentElement.parentElement.style = "background:white;color:black !important;";
    }
  };

  const toggleModalExplanation = () => {
    setState(prevState => ({ ...prevState, explanationModalWriting: !prevState.explanationModalWriting }));
  };

  const renderOption = useCallback((item) => {
    const currentQuestion = state.questionData[state.currentQuestion];

    const isSelected = currentQuestion.answer
      ?.split(",")
      .includes(item.id.toString());

    const isCorrect = item.correct === 1;

    let optionClass = "option-box";

    if (isCorrect && isSelected) {
      optionClass += " option-correct-selected";
    } else if (isCorrect && !isSelected) {
      optionClass += " option-correct-not-selected";
    } else if (!isCorrect && isSelected) {
      optionClass += " option-wrong-selected";
    }else{
      optionClass += " option-default";
    }
    
    // if (isSelected && isCorrect) return "option-correct-selected";
    // if (isSelected && !isCorrect) return "option-wrong-selected";
    // if (!isSelected && isCorrect) return "option-correct-not-selected";

    return (
      <Form.Label key={item.id} className="option-label w-100">
        <div className={optionClass}>
          <Checkbox
            checked={isSelected}
            value={item.id}
            disabled
          />
          <span className="option-text">{item.options}</span>
        </div>
      </Form.Label>
    );
  }, [state.currentQuestion, state.questionData]);

//    const displayResult = () => {
//   const q_data = state.questionData?.[state.currentQuestion];
//   if (!q_data) return; // 🔒 React 19 safety

//   /* ===============================
//      PRE CALC (UNCHANGED)
//   ================================*/
//   if (q_data.type === 11 || q_data.type === 12) {
//     const correct = q_data.correct;
//     const corArray = correct?.split(',').map(i => i.trim());
//     const selArray = q_data.answer?.split(',').map(i => i.trim());

//     const selectedArray = corArray?.map((item, index) =>
//       selArray?.[index] && selArray[index] !== '-' ? selArray[index] : '__'
//     );

//     if (q_data.explanation?.status) {
//       setState(prev => ({ ...prev, option_explaination: q_data.explanation }));
//     }
//   }

//   let selected_arr = [];
//   let correct_arr = [];

//   /* ===============================
//      SWITCH START
//   ================================*/
//   switch (q_data.type) {

//     /* ---------- CASE 11 ---------- */
//     case 11: {
//       const selectedEls = document.querySelectorAll('.selected-option');
//       const answers = q_data.answer?.split(',') || [];
//       const corrects = q_data.correct?.split(',') || [];

//       if (answers.length) {
//         answers.forEach((v, k) => {
//           if (!selectedEls[k]) return;

//           selectedEls[k].innerHTML =
//             v.trim() === corrects[k]?.trim()
//               ? `<span class="right-blank">${v}&nbsp;<i class="fa fa-check" style="font-size:16px;"></i></span>`
//               : `<span class="wrong-blank">${v}&nbsp;<i class="fa fa-times" style="font-size:16px;"></i></span>`;
//         });
//       } else {
//         corrects.forEach((_, k) => {
//           if (!selectedEls[k]) return;
//           selectedEls[k].innerHTML =
//             `<span class="wrong-blank">&nbsp;<i class="fa fa-times" style="font-size:16px;"></i></span>`;
//         });
//       }
//       break;
//     }

//     /* ---------- CASE 10 ---------- */
//     case 10: {
//       const elemArr = document.querySelectorAll('.list-group-item1');
//       elemArr.forEach(el => el?.classList?.add('cross'));

//       if (q_data.answer && q_data.correct) {
//         const answer = q_data.answer.split(',');
//         const correct = q_data.correct.split(',');

//         for (let i = 0; i < answer.length - 1; i++) {
//           for (let j = 0; j < correct.length - 1; j++) {
//             if (
//               correct.length > i + 1 &&
//               answer[i] + '-' + answer[i + 1] === correct[j] + '-' + correct[j + 1]
//             ) {
//               elemArr[i]?.classList?.remove('cross');
//             }
//           }
//         }
//       }
//       break;
//     }

//     /* ---------- CASE 16 ---------- */
//     case 16: {
//       const selectedEls = document.querySelectorAll('.selected-option');

//       if (!q_data.answer || q_data.answer === '-') {
//         selectedEls.forEach(el => {
//           el.innerHTML =
//             `<span class="wrong-blank">&nbsp;<i class="fa fa-times" style="font-size:16px;"></i></span>`;
//         });
//       } else {
//         const userAnswers = q_data.answer.split(',');
//         const correctAnswers = q_data.correct?.split(',') || [];

//         userAnswers.forEach((v, k) => {
//           if (!selectedEls[k]) return;

//           selectedEls[k].innerHTML =
//             v.trim() === correctAnswers[k]?.trim()
//               ? `<span class="right-blank">${v}&nbsp;<i class="fa fa-check" style="font-size:16px;"></i></span>`
//               : `<span class="wrong-blank">${v}&nbsp;<i class="fa fa-times" style="font-size:16px;"></i></span>`;
//         });
//       }
//       break;
//     }

//     /* ---------- CASE 12 ---------- */
//     case 12: {
//       const selectedEls = document.querySelectorAll('.selected-option');
//       const corrects = q_data.correct?.split(',') || [];

//       corrects.forEach((_, k) => {
//         if (!selectedEls[k]) return;
//         selectedEls[k].innerHTML =
//           `<span class="wrong-blank">&nbsp;<i class="fa fa-times" style="font-size:16px;"></i></span>`;
//       });

//       if (q_data.answer) {
//         q_data.answer.split(',').forEach((v, k) => {
//           if (!selectedEls[k]) return;

//           selectedEls[k].innerHTML =
//             v.trim() === corrects[k]?.trim()
//               ? `<span class="right-blank">${v}&nbsp;<i class="fa fa-check" style="font-size:16px;"></i></span>`
//               : `<span class="wrong-blank">${v}&nbsp;<i class="fa fa-times" style="font-size:16px;"></i></span>`;
//         });
//       }
//       break;
//     }

//     /* ---------- CASE 15 ---------- */
//     case 15:
//       changeColorReset();

//       correct_arr = q_data.correct ? q_data.correct.split(',').map(i => i.trim()) : [];
//       selected_arr = q_data.answer ? q_data.answer.split(',').map(i => i.trim()) : [];

//       setState(prev => ({ ...prev, correctArray: correct_arr, selectedArray: selected_arr }));

//       selected_arr.forEach(k => {
//         const row = document.querySelector(`input[value="${k}"]`)
//           ?.parentElement?.parentElement?.parentElement;
//         if (!row) return;

//         row.style = correct_arr.includes(k) ? "background:green" : "background:red";
//       });

//       correct_arr
//         .filter(x => !selected_arr.includes(x))
//         .forEach(k => {
//           const row = document.querySelector(`input[value="${k}"]`)
//             ?.parentElement?.parentElement?.parentElement;
//           if (row) row.style = "background:blue";
//         });

//       break;

//     /* ---------- CASE 9 ---------- */
//     case 9:
//       changeColorReset();

//       correct_arr = q_data.correct ? q_data.correct.split(',').map(i => i.trim()) : [];
//       selected_arr = q_data.answer ? q_data.answer.split(',').map(i => i.trim()) : [];

//       selected_arr.forEach(k => {
//         const row = document.querySelector(`input[value="${k}"]`)
//           ?.parentElement?.parentElement?.parentElement;
//         if (!row) return;

//         row.style = correct_arr.includes(k) ? "background:green" : "background:red";
//       });

//       correct_arr
//         .filter(x => !selected_arr.includes(x))
//         .forEach(k => {
//           const row = document.querySelector(`input[value="${k}"]`)
//             ?.parentElement?.parentElement?.parentElement;
//           if (row) row.style = "background:blue";
//         });
//       break;

//     /* ---------- CASE 8 ---------- */
//     case 8:
//       changeColorReset();

//       if (q_data.answer && q_data.correct?.trim() === q_data.answer.trim()) {
//         const row = document.querySelector(`input[value="${q_data.answer}"]`)
//           ?.parentElement?.parentElement?.parentElement;
//         if (row) row.style = "background:green";
//       } else {
//         if (q_data.answer) {
//           const row = document.querySelector(`input[value="${q_data.answer}"]`)
//             ?.parentElement?.parentElement?.parentElement;
//           if (row) row.style = "background:red";
//         }
//         if (q_data.correct) {
//           const row = document.querySelector(`input[value="${q_data.correct}"]`)
//             ?.parentElement?.parentElement?.parentElement;
//           if (row) row.style = "background:blue";
//         }
//       }
//       break;

//     /* ---------- CASE 14 ---------- */
//     case 14:
//     /* ---------- CASE 17 ---------- */
//     case 17:
//     /* ---------- CASE 18 ---------- */
//     case 18:
//       changeColorReset();

//       if (q_data.answer && q_data.correct?.trim() === q_data.answer.trim()) {
//         const row = document.querySelector(`input[value="${q_data.answer}"]`)
//           ?.parentElement?.parentElement?.parentElement;
//         if (row) row.style = "background:green";
//       } else {
//         if (q_data.answer) {
//           const row = document.querySelector(`input[value="${q_data.answer}"]`)
//             ?.parentElement?.parentElement?.parentElement;
//           if (row) row.style = "background:red";
//         }
//         if (q_data.correct) {
//           const row = document.querySelector(`input[value="${q_data.correct}"]`)
//             ?.parentElement?.parentElement?.parentElement;
//           if (row) row.style = "background:blue";
//         }
//       }
//       break;

//     /* ---------- CASE 19 ---------- */
//     case 19: {
//       const container = document.querySelector('.result-correct');
//       if (!container) break;

//       container.innerHTML = q_data.html || '';

//       const userSelected = q_data.answer?.split(',').map(i => i.trim()) || [];
//       const correctAnswers = q_data.correct?.split(',').map(i => i.trim()) || [];

//       container.querySelectorAll('span').forEach(span => {
//         const text = span.textContent.trim();

//         if (span.classList.contains('highlight1')) {
//           span.innerHTML = `${text}&nbsp;<i class="fa ${
//             correctAnswers.includes(text) ? 'fa-check' : 'fa-times'
//           }" style="font-size:16px;"></i>`;
//           span.style = correctAnswers.includes(text)
//             ? "background:green;color:white"
//             : "background:red;color:white";
//         } else if (correctAnswers.includes(text) && !userSelected.includes(text)) {
//           span.style = "background:blue;color:white";
//         }
//       });
//       break;
//     }

//     default:
//       break;
//   }
// };

  const displayResult = () => {
    let q_data = state.questionData[state.currentQuestion];
    if (q_data.type === 11 || q_data.type === 12) {
      const correct = q_data.correct;
      const corArray = correct?.split(',').map(item => item.trim());
      const selArray = q_data.answer?.split(',').map(item => item.trim());
      const selectedArray = corArray.map((item, index) => (selArray?.[index] && selArray?.[index] !== '-') ? selArray[index].trim() : '__');

      if ('explanation' in q_data && q_data.explanation.status) {
        setState(prevState => ({ ...prevState, option_explaination: q_data.explanation }));
      }
    }

    let selected_arr = [];
    let correct_arr = [];

    switch (q_data.type) {
      case 11:
        if (q_data.answer) {
          q_data.answer.split(',').map((v, k) => {
            if (v.trim() === q_data.correct.split(',')[k].trim()) {
              document.querySelectorAll('.selected-option')[k].innerHTML = '<span className="right-blank">' + q_data.answer.split(',')[k] + '&nbsp; <i className="fa fa-check" style="font-size:16px;"></i></span>';
            } else {
              if (document.querySelectorAll('.selected-option').length > k) {
                document.querySelectorAll('.selected-option')[k].innerHTML = '<span className="wrong-blank">' + q_data.answer.split(',')[k] + '&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>';
              }
            }
          });
        } else {
          q_data.correct.split(',').map((v, k) => {
            document.querySelectorAll('.selected-option')[k].innerHTML = '<span className="wrong-blank">&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>';
          });
        }
        break;
      // case 10:
      //   let elemArr = document.querySelectorAll('.list-group-item1');
      //   for (var i = 0; i < elemArr.length; i++) {
      //     elemArr[i].classList.add('cross');
      //   }

      //   if (q_data.answer) {
      //     let correct = q_data.correct.split(',');
      //     let answer = q_data.answer.split(',');
      //     for (var i = 0; i < answer.length - 1; i++) {
      //       for (var j = 0; j < correct.length - 1; j++) {
      //         if (correct.length > i + 1) {
      //           if (answer[i] + '-' + answer[i + 1] == correct[j] + '-' + correct[j + 1]) {
      //             elemArr[i].classList.remove('cross');
      //           }
      //         }
      //       }
      //     }
      //   }
      //   break;
      case 10: {
  const elemArr = document.querySelectorAll('.list-group-item1');

  elemArr.forEach(el => {
    el?.classList?.add('cross');
  });

  if (q_data.answer) {
    const correct = q_data.correct.split(',');
    const answer = q_data.answer.split(',');

    for (let i = 0; i < answer.length - 1; i++) {
      for (let j = 0; j < correct.length - 1; j++) {
        if (
          correct.length > i + 1 &&
          answer[i] + '-' + answer[i + 1] === correct[j] + '-' + correct[j + 1]
        ) {
          if (elemArr[i]) {
            elemArr[i].classList.remove('cross');
          }
        }
      }
    }
  }
  break;
}

      // case 16:
      //   console.log(q_data); 
      //   if (q_data.answer === "-") {
      //     let allInput = document.querySelectorAll('.selected-option');
      //     for (var i = 0; i < allInput.length; i++) {
      //       allInput[i].innerHTML = '<span class="wrong-blank">&nbsp; <i class="fa fa-times" style="font-size:16px;"></i></span>';
      //     }
      //   } else {
      //     q_data.answer.split(',').map((v, k) => {
      //       if (v.trim() === q_data.correct.split(',')[k].trim()) {
      //         document.querySelectorAll('.selected-option')[k].innerHTML = '<span class="right-blank">' + q_data.answer.split(',')[k] + '&nbsp; <i class="fa fa-check" style="font-size:16px;"></i></span>';
      //       } else {
      //         if (document.querySelectorAll('.selected-option').length > k) {
      //           document.querySelectorAll('.selected-option')[k].innerHTML = '<span class="wrong-blank">' + q_data.answer.split(',')[k] + '&nbsp; <i class="fa fa-times" style="font-size:16px;"></i></span>';
      //         }
      //       }
      //     });
      //   }
      //   break;
      case 16:
  if (q_data.answer === "-" || !q_data.answer) {
    const correctAnswers = q_data.correct.split(',');
    let allInput = document.querySelectorAll('.selected-option');
    for (var i = 0; i < allInput.length; i++) {
      if (correctAnswers[i]) {
        allInput[i].innerHTML = '<span class="not-selected">' + correctAnswers[i].trim() + '</span>';
        allInput[i].style = "background:blue;color:white;";
      }
    }
  } else if (q_data.answer && q_data.correct) {
    const userAnswers = q_data.answer.split(',');
    const correctAnswers = q_data.correct.split(',');
    
    userAnswers.map((v, k) => {
      const selectedElements = document.querySelectorAll('.selected-option');
      if (selectedElements[k]) {
        if (v.trim() === "-" || !v.trim()) {
          // Show correct answer in blue for unanswered blanks
          selectedElements[k].innerHTML = '<span class="not-selected">' + correctAnswers[k].trim() + '</span>';
          selectedElements[k].style = "background:blue;color:white;";
        } else if (v.trim() === correctAnswers[k]?.trim()) {
          selectedElements[k].innerHTML = '<span class="right-blank">' + v + '&nbsp; <i class="fa fa-check" style="font-size:16px;"></i></span>';
        } else {
          selectedElements[k].innerHTML = '<span class="wrong-blank">' + v + '&nbsp; <i class="fa fa-times" style="font-size:16px;"></i></span>';
        }
      }
    });
  }
  break;
  case 12: {
  const isNotAnswered = !q_data?.answer || 
    q_data.answer.split(',').every(v => v.trim() === '-' || !v.trim());
  
  if (isNotAnswered) break;
  
  q_data.answer.split(',').forEach((v, k) => {
    const el = document.querySelectorAll('.selected-option')[k];
    if (el && v.trim() !== '-') {
      el.innerHTML = v.trim() === q_data.correct.split(',')[k]?.trim()
        ? '<span class="right-blank">' + v.trim() + '&nbsp; <i class="fa fa-check" style="font-size:16px;"></i></span>'
        : '<span class="wrong-blank">' + v.trim() + '&nbsp; <i class="fa fa-times" style="font-size:16px;"></i></span>';
    }
  });
  break;
}
      // case 12:
      //   if (q_data?.answer) {
      //     console.log("Here is the answer : ".q_data);
      //     q_data.correct.split(',').map((v, k) => {
      //       document.querySelectorAll('.selected-option')[k].innerHTML = '<span className="wrong-blank">&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>';
      //     });
      //     q_data.answer.split(',').map((v, k) => {
      //       console.log("Here is the answer : ".q_data.answer);
      //       if (v.trim() === q_data.correct.split(',')[k].trim()) {
      //         document.querySelectorAll('.selected-option')[k].innerHTML = '<span className="right-blank">' + q_data.answer.split(',')[k] + '&nbsp; <i className="fa fa-check" style="font-size:16px;"></i></span>';
      //       } else {
      //         if (document.querySelectorAll('.selected-option').length > k) {
      //           document.querySelectorAll('.selected-option')[k].innerHTML = '<span className="wrong-blank">' + q_data.answer.split(',')[k] + '&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>';
      //         }
      //       }
      //     });
      //   } 
      //   break;
        // else {
        //   q_data.correct.split(',').map((v, k) => {
        //     document.querySelectorAll('.selected-option')[k].innerHTML = '<span className="wrong-blank">&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>';
        //   });
        // }
      case 15:
        changeColorReset();
        correct_arr = [];
        selected_arr = [];
        if (q_data.correct) {
          correct_arr = q_data.correct.split(',').map(item => item.trim());
          setState(prevState => ({ ...prevState, correctArray: correct_arr }));
        }
        if (q_data.answer) {
          selected_arr = q_data.answer.split(',').map(item => item.trim());
          setState(prevState => ({ ...prevState, selectedArray: selected_arr }));
          selected_arr.map((k) => {
            if (correct_arr.includes(k)) {
              document.querySelector('input[value="' + k + '"]').parentElement.parentElement.parentElement.style = "background:green";
            } else {
              document.querySelector('input[value="' + k + '"]').parentElement.parentElement.parentElement.style = "background:red";
              console.log(document.querySelector('input[value="' + k + '"]').parentElement.parentElement.parentElement,"Here the stylde was changed")
            }
          });
        }
        let result = correct_arr.filter(x => !selected_arr.includes(x));
        console.log(result);
        result.map((k) => {
          document.querySelector('input[value="' + k + '"]').parentElement.parentElement.parentElement.style = "background:blue";
        });
        if (q_data.correct) {
          //document.querySelector('input[value="'+q_data.correct+'"]').parentElement.parentElement.parentElement.style="background:blue";
        } else {
          let correct = q_data.question.option.filter((p) => { if (p && p.correct === 1) return p; });
          correct.map((p) => {
            document.querySelector('input[value="' + p.id + '"]').parentElement.parentElement.parentElement.style = "background:blue";
          });
        }
        break;
      case 18:
        changeColorReset();
        if (q_data.answer != null && q_data.correct.trim() === q_data.answer.trim()) {
          document.querySelector('input[value="' + q_data.answer + '"]').parentElement.parentElement.parentElement.style = "background:green";
        } else {
          if (q_data.answer != null) {
            document.querySelector('input[value="' + q_data.answer + '"]').parentElement.parentElement.parentElement.style = "background:red";
          }
          document.querySelector('input[value="' + q_data.correct + '"]').parentElement.parentElement.parentElement.style = "background:blue";
        }
        break;
      case 17:
        changeColorReset();
        if (q_data.answer != null && q_data.correct.trim() === q_data.answer.trim()) {
          document.querySelector('input[value="' + q_data.answer + '"]').parentElement.parentElement.parentElement.style = "background:green";
        } else {
          if (q_data.answer != null) {
            document.querySelector('input[value="' + q_data.answer + '"]').parentElement.parentElement.parentElement.style = "background:red";
          }
          document.querySelector('input[value="' + q_data.correct + '"]').parentElement.parentElement.parentElement.style = "background:blue";
        }
        break;
      case 14:
        changeColorReset();
        if (q_data.answer && q_data.correct.trim() === q_data.answer.trim()) {
          document.querySelector('input[value="' + q_data.answer + '"]').parentElement.parentElement.parentElement.style = "background:green";
        } else {
          if (q_data.answer) {
            document.querySelector('input[value="' + q_data.answer + '"]').parentElement.parentElement.parentElement.style = "background:red";
          }
          if (q_data.correct) {
            document.querySelector('input[value="' + q_data.correct + '"]').parentElement.parentElement.parentElement.style = "background:blue";
          } else {
            let correct = q_data.question.option.filter((p) => { if (p && p.correct === 1) return p; });
            document.querySelector('input[value="' + correct[0].id + '"]').parentElement.parentElement.parentElement.style = "background:blue";
          }
        }
        break;
      case 8:
        changeColorReset();
        if (q_data.answer && q_data.answer != null && q_data.correct.trim() === q_data.answer.trim()) {
          document.querySelector('input[value="' + q_data.answer + '"]').parentElement.parentElement.parentElement.style = "background:green";
        } else {
          if (q_data.answer && q_data.answer != null) {
            document.querySelector('input[value="' + q_data.answer + '"]').parentElement.parentElement.parentElement.style = "background:red";
          }
          if (q_data.correct) {
            document.querySelector('input[value="' + q_data.correct + '"]').parentElement.parentElement.parentElement.style = "background:blue";
          } else {
            let correct = q_data.question.option.filter((p) => { if (p && p.correct === 1) return p; });
            document.querySelector('input[value="' + correct[0].id + '"]').parentElement.parentElement.parentElement.style = "background:blue";
          }
        }
        break;
      case 9:
        changeColorReset();
        correct_arr = [];
        if (q_data.correct) {
          correct_arr = q_data.correct.split(',').map(item => item.trim());
        }
        if (q_data.answer) {
          selected_arr = q_data.answer.split(',').map(item => item.trim());
          selected_arr.map((k) => {
            if (correct_arr.includes(k)) {
              if (document.querySelector('input[value="' + k + '"]')) {
                document.querySelector('input[value="' + k + '"]').parentElement.parentElement.parentElement.style = "background:green";
              }
            } else {
              if (document.querySelector('input[value="' + k + '"]')) {
                document.querySelector('input[value="' + k + '"]').parentElement.parentElement.parentElement.style = "background:red";
              }
            }
          });
        }
        let result1 = correct_arr.filter(x => !selected_arr.includes(x));
        result1.map((k) => {
          if (document.querySelector('input[value="' + k + '"]')) {
            document.querySelector('input[value="' + k + '"]').parentElement.parentElement.parentElement.style = "background:blue";
          }
        });
        if (!q_data.correct) {
          let correct = q_data.question.option.filter((p) => { if (p && p.correct === 1) return p; });
          correct.map((p) => {
            document.querySelector('input[value="' + p.id + '"]').parentElement.parentElement.parentElement.style = "background:blue";
          });
        }
        break;
      // case 19:
      //   if (state.questionData.length > 0) {
      //     document.querySelector('.result-correct').innerHTML = state.questionData[state.currentQuestion].html;
      //   }
      //   let elem = document.querySelectorAll('.result-correct span');
      //   for (var i = 0; i < elem.length; i++) {
      //     let hig = document.querySelectorAll('.result-correct span')[i].classList.value;
      //     let higText = document.querySelectorAll('.result-correct span')[i].textContent;
      //     if (hig == "correct hidd") {
      //       document.querySelectorAll('.result-correct span')[i - 1].style = "background:blue;color:white";
      //     }
      //   }
      //   for (var i = 0; i < elem.length; i++) {
      //     let hig = document.querySelectorAll('.result-correct span')[i].classList.value;
      //     let higText = document.querySelectorAll('.result-correct span')[i].textContent;
      //     let corr = "";
      //     if (elem.length > (i + 1)) {
      //       corr = document.querySelectorAll('.result-correct span')[i + 1].classList.value;
      //     }
      //     if (hig == "highlight1") {
      //       if (corr == "correct hidd") {
      //         document.querySelectorAll('.result-correct span')[i].innerHTML = higText + '&nbsp; <i className="fa fa-check" style="font-size:16px;"></i></span>';
      //         document.querySelectorAll('.result-correct span')[i].style = "background:green";
      //       } else {
      //         document.querySelectorAll('.result-correct span')[i].innerHTML = higText + '&nbsp; <i className="fa fa-times" style="font-size:16px;"></i></span>';
      //         document.querySelectorAll('.result-correct span')[i].style = "background:red";
      //       }
      //     }
      //   }
      //   break;
      case 19:
  if (state.questionData.length > 0) {
    document.querySelector('.result-correct').innerHTML = state.questionData[state.currentQuestion].html;
  }
  
  const userSelected = state.questionData[state.currentQuestion].answer ? 
    state.questionData[state.currentQuestion].answer.split(',').map(item => item.trim()) : [];
  const correctAnswers = state.questionData[state.currentQuestion].correct ? 
    state.questionData[state.currentQuestion].correct.split(',').map(item => item.trim()) : [];
  
  let elem = document.querySelectorAll('.result-correct span');
  
  // Mark all spans based on their content and user selection
  for (var i = 0; i < elem.length; i++) {
    let hig = elem[i].classList.value;
    let higText = elem[i].textContent.trim();
    
    if (hig == "highlight1") {
      // User selected this word
      if (correctAnswers.includes(higText)) {
        elem[i].innerHTML = higText + '&nbsp; <i class="fa fa-check" style="font-size:16px;"></i>';
        elem[i].style = "background:green;color:white";
      } else {
        elem[i].innerHTML = higText + '&nbsp; <i class="fa fa-times" style="font-size:16px;"></i>';
        elem[i].style = "background:red;color:white";
      }
    } else if (correctAnswers.includes(higText) && !userSelected.includes(higText)) {
      // Correct answer that user didn't select
      elem[i].style = "background:blue;color:white";
    }
  }
  break;

      default:
    }
  };

  const showQuestion = (type) => {
    return <Navigate to={"/practice/" + type} replace />;
  };

  const submitResponse = (data) => { };

  const showScore = (e, id) => {
    let {
      type, template_type, template_issue, common_sentence, score, no_of_repeat_allowed
    } = state.questionData[state.currentQuestion];

    if ([3, 4].includes(type, template_type) && ["repeat", "common"].includes(template_type) && (template_issue != '' || common_sentence != '')) {
      setState(prevState => ({
        ...prevState,
        templateDetectorModalProps: {
          title:
            template_type === "repeat"
              ? template_issue
              : template_type === "common"
                ? common_sentence
                : "",
          template_type: template_type,
          common_sentence: common_sentence,
          data: {
            remarks: score[0].remarks,
            no_of_repeat_allowed,
            overallScore: { score: ((score[0].score + score[1].score + score[2].score) / 3), out_of: score[0].from },
            contentScore: { score: score[0].score, out_of: score[0].from },
            fluencyScore: { score: score[1].score, out_of: score[1].from },
            pronunciationScore: { score: score[2].score, out_of: score[2].from },
          }
        },
        explanationModal: true
      }));
    } else {
      setState(prevState => ({
        ...prevState,
        modal: !prevState.modal,
        id
      }));
    }
  };

  const closeModalExplanation = () => {
    setState(prevState => ({ ...prevState, explanationModal: false }));
  };

  const toggle = () => {
    setState(prevState => ({ ...prevState, modal: !prevState.modal }));
  };

  // const showHistoryFunc = () => {
  //   let id = state.questionData[state.currentQuestion].id;
  //   let arr = state.questionData.map((v) => { if (id === v.id) { return v.score } });
  //   let arr1 = arr.filter((va) => { if (typeof va === "object") { return va; } })[0];
  //   console.log("arr1:", arr1);
    
  //   let a = arr1.map((v) => { return (`<tr><td>${remarks(v.type)}</td><td>${v.score}/${v.from}</td><td>${v.remarks}</td></tr>`) });
  //   if ([6, 7, 13].includes(state.questionData[state.currentQuestion].type)) {
  //     let t_from = 0;
  //     let t_score = 0;
  //     for (var i = 0; i <= arr1.length - 1; i++) {
  //       t_from += arr1[i].from;
  //       t_score += arr1[i].score;
  //     }
  //     a.push('<tr><td>Total</td><td colspan="2">' + t_score + '/' + t_from + '</td></tr>');
  //   }
  //   return a;
  // };

  const showHistoryFunc1 = () => {
  const question = state.questionData[state.currentQuestion];
  
  if (!question || !Array.isArray(question.score)) return [];

  const arr1 = question.score;

  let totalScore = 0;
  let totalFrom = 0;

  const rows = arr1.map((v) => {
    totalScore += v.score;
    totalFrom += v.from;

    // status logic
    const percent = v.from ? (v.score / v.from) * 100 : 0;
    let status = "Average";
    let badgeClass = "badge-warning";
    console.log("Prec : ",percent);
    
    if (percent >= 85) {
      status = "Perfect";
      badgeClass = "badge-success";
    } else if (percent >= 70) {
      status = "Good";
      badgeClass = "badge-success";
    }

    const iconSrc = getIconByType(v.type) || "/icons/default.svg";

    // remarks list
    const remarksList = `<li class="mx-3">${v.remarks}</li>`;

    return `
      <div class="performance-item">
        <div class="item-header">
          <div class="item-title">
            <img src="${iconSrc}" alt="${remarks(v.type)}" style="max-height:30px;" />
            <span>${remarks(v.type)}</span>
          </div>

          <span class="score">${v.score}/${v.from}</span>
        </div>

        <ul>
          ${remarksList}
        </ul>
      </div>
    `;
  });

  // total row (for specific question types)
    if([1,2,3,4,21,22].includes(question.question.subcategory_id)) {
			totalFrom = totalFrom / arr1.length;
      totalScore = totalScore / arr1.length;
      rows.push(`
        <div class="performance-item total">
          <div class="item-header">
            <div class="item-title">
              <span>Total</span>
            </div>
            <span class="score fw-bold">${Math.round(totalScore)}/${totalFrom}</span>
          </div>
        </div>
      `);
		}else{
      rows.push(`
        <div class="performance-item total">
          <div class="item-header">
            <div class="item-title">
              <span>Total</span>
            </div>
            <span class="score fw-bold">${totalScore}/${totalFrom}</span>
          </div>
        </div>
      `);
    }
  // if ([6, 7, 13].includes(question.type)) {}

  return rows;
};

  const showScoreAnalysis = () => {
    const question = state.questionData[state.currentQuestion];
    if (!question || !Array.isArray(question.score)) return [];

    return question.score.map((v) => {
      const percent = v.from ? Math.round((v.score / v.from) * 100) : 0;

      let color = "#facc15"; // warning
      if (percent >= 85) color = "#22c55e"; // success
      else if (percent >= 70) color = "#4ade80"; // good

      return `
        <div class="overall-card">
          <div class="progress-circle"
          style="background: conic-gradient(${color} ${percent}%, #e6e6e6 0);">
            <div class="progress-inner">
            ${v.from == 0 ? `<div class="remarks">N/A</div>` : 
            `<div class="score-main">${v.score}</div>
              <div class="score-sub">/ ${v.from}</div>`
          }
            </div>
          </div>
          <div class="overall-text">${remarks(v.type)}</div>
        </div>
      `;
    });
  };

  const remarks = (type) => {
    let str = "";
    switch (type) {
      case 0:
        str = "Content";
        break;
      case 1:
        str = "Fluency";
        break;
      case 2:
        str = "Pronunciation";
        break;
      case 3:
        str = "Score";
        break;
      case 4:
        str = "Grammar";
        break;
      case 5:
        str = "Form";
        break;
      case 6:
        str = "Vocabulary";
        break;
      case 7:
        str = "Spelling";
        break;
      case 8:
        str = "Linguistic range";
        break;
      case 9:
        str = "Structure";
        break;
      default:
        str = "";
    }
    return str;
  };

  const getIconByType = (type) => {
    switch (type) {
      case 0:
        return Content;

      case 1:
        return Fluency;

      case 2:
        return Pronunciation;

      case 3:
        return ScoreIcon;

      case 4:
        return Grammar;

      case 5:
        return FormIcon;

      case 6:
        return Vocabulary;

      case 7:
        return BarFrequency;

      case 8:
        return linguistic;

      case 9:
        return Structure;

      default:
        return "";
    }
  };

  const resultStatus = () => {
    setState(prevState => ({ ...prevState, is_result: true }));
  };

  const soundChecked = () => { };
  const stopRecording = () => { };
  const nextQuestion = () => { };

  const changeQuestion = (e, k) => {
    let question = state.questionData[k];
    let state_obj = {
      result: {},
      currentQuestion: k,
      type: question.question.subcategory_id
    };
    if ('explanation' in question) {
      state_obj.option_explaination = question.explanation;
    }

    setState(prevState => ({ ...prevState, ...state_obj }));
  };

  const nextButton = () => {
    let question = state.questionData[state.currentQuestion + 1];
    let state_obj = {
      result: {},
      currentQuestion: state.currentQuestion + 1,
      type: question.question.subcategory_id
    };
    if ('explanation' in question) {
      state_obj.option_explaination = question.explanation;
    }

    setState(prevState => ({ ...prevState, ...state_obj }));
  };

  const prevButton = () => {
    let question = state.questionData[state.currentQuestion - 1];
    let state_obj = {
      result: {},
      currentQuestion: state.currentQuestion - 1,
      type: question.question.subcategory_id
    };

    if ('explanation' in question) {
      state_obj.option_explaination = question.explanation;
    }

    setState(prevState => ({ ...prevState, ...state_obj }));
  };

  const finalSubmit = () => { };

  const renderResponse = (html) => {
  const q_data = state.questionData[state.currentQuestion];

  // If user answered nothing BUT question is marked attempted
  if (
    q_data?.not_attempted === 0 && 
    (
    html === null ||
    html === undefined ||
    html === "" ||
    html === "[]" ||
    html.trim() === "" ||
    html.trim() === "<span class=\"text-danger\"></span>" ||
    html.trim() === "<span class=\"text-danger\"><\/span>" ||
    html.trim() === "<span class='text-danger'></span>" ||
    html.trim() === "<span class=\"text-success\"></span>"
    )
  ) {
    return <span className="text-danger">Not Answered</span>;
  }
  let items = [];

  // Handle empty or null html
  if  (q_data?.not_attempted !== 0 && (
    html === null ||
    html === undefined ||
    html === "" ||
    html === "[]" ||
    html.trim() === "" ||
    html.trim() === "<span class=\"text-danger\"></span>" ||
    html.trim() === "<span class=\"text-danger\"><\/span>" ||
    html.trim() === "<span class='text-danger'></span>"
  ) ){
    return <span className="text-danger">Not Attempted</span>;
  }

  // 2️⃣ If HTML starts with "<", treat as raw HTML
  if (typeof html === "string" && html.trim().startsWith("<")) {
    return ReactHtmlParser(html);
  }

  // 3️⃣ Try parsing JSON
  try {
    if (typeof html === "string") {
      const parsed = JSON.parse(html);
      items = Array.isArray(parsed) ? parsed : [parsed];
    } else if (typeof html === "object") {
      items = Array.isArray(html) ? html : [html];
    }

    // 4️⃣ Empty array after JSON parse
    if (!items || items.length === 0) {
      return <span>No response provided</span>;
    }
  } catch (err) {
    console.error("Error parsing response:", err);
    return <span>Sorry, we couldn’t show the response due to a technical issue. Your results are not affected.
 </span>;
  }

  // 5️⃣ Render JSON items
  return (
    <>
      {items.map((item, i) => {
        if (state.questionData[0].subcategory_id === 5) {
          return (
            <span key={i}>
              <span>Your Response: </span>
              <span className={item.class}>
                {item.word !== "&nbsp;" ? item.word : " "}
              </span>
            </span>
          );
        }

        return <TooltipItem key={i} item={item} id={i} />;
      })}
    </>
  );
};

const stripHtml = (html = '') => {
  if (!html) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

const isEmptyHtml = (html) => {
  if (!html) return true;

  if (typeof html !== "string") return false;

  const cleaned = html
    .replace(/<[^>]*>/g, "") 
    .replace(/&nbsp;/g, "")
    .trim();

  return cleaned === "" || html === "[]" || html === "{}" || html === "null";
};

const renderSimpleResponse = (html) => {
  const q_data = state.questionData[state.currentQuestion];

  if (q_data?.not_attempted !== 0) {
    return <h5 className="text-danger">Not Attempted</h5>;
  }

  if (isEmptyHtml(html)) {
    return <h5 className="text-danger">Not Answered</h5>;
  }

  return <h5>{ReactHtmlParser(html)}</h5>;
};


  const showExplanation = () => {
    setState(prevState => ({ ...prevState, paragraphExplainationModal: true }));
  };

  const toggleModal = () => {
    setState(prevState => ({ ...prevState, paragraphExplainationModal: !prevState.paragraphExplainationModal }));
  };
  
  const getPairClass = (index) => {
    const correctPair = val.correct.split(",");
    const answerPair = val.answer ? val.answer.split(",") : [];

    if (!answerPair[index]) return "";

    if (answerPair[index] === correctPair[index]) {
      return "";
    }

    if (correctPair.includes(answerPair[index])) {
      return "cross";
    }

    return "";
  };

  const showParagraphExplanationButton = () => {
    if ([11, 12].includes(parseInt(state.type))) {
      let question = state.questionData[state.currentQuestion];
      if ('explanation' in question && 'paragraph_explanation' in question.explanation) {
        return true;
      }
    }
    return false;
  };

  if (state.questionData) {
    props = {
      submit: submitResponse,
      showResult: resultStatus,
      data: state.questionData[state.currentQuestion].question,
      answer: true,
      resultMode: true,
      testMode: false,
      soundChecked: soundChecked,
      stopRecording: stopRecording,
      nextQuestion: nextQuestion,
      selectedArray : state.selectedArray,
      correctArray : state.correctArray
    };
    val = state.questionData[state.currentQuestion];
  }
  let title = "";
  let ques_title = "";
  if (state.questionData.length > 0) {
    ques_title = state.questionData[state.currentQuestion].q_title;
  }

  switch (state.type) {
    case 1:
      que = <ReadAloud {...props} key={state.currentQuestion} />;
      title = "Look at the text below. In 35 seconds, you must read this text aloud as naturally and clearly as possible. You have 35 seconds to read aloud.";
      break;
    case 2:
      que = <RepeatSentece {...props} key={state.currentQuestion} />;
      title = "You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.";
      break;
    case 3:
      que = <DescribeImage {...props} key={state.currentQuestion} />;
      title = "Look at the image below. In 25 seconds, please speak into the microphone and describe in detail what the image is showing. You will have 40 seconds to give your response.";
      break;
    case 4:
      que = <RetellLec {...props} key={state.currentQuestion} />;
      title = "You will hear a lecture. After listening to the lecture, in 10 seconds, please speak into the microphone and retell what you have just heard from the lecture in your own words. You will have 40 seconds to give your response.";
      break;
    case 5:
      que = <ShortQue {...props} key={state.currentQuestion} />;
      title = "You will hear a question. Please give a simple and short answer. Often just one or a few words is enough.";
      break;
    case 6:
      que = <Summary {...props} key={state.currentQuestion} />;
      title = "Read the passage and summarise it using one sentence. Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. Your response will be judged on the quality of your writing and on how well your response presents the key points in the passage.";
      break;
    case 7:
      que = <Essay {...props} key={state.currentQuestion} />;
      title = "You will have 20 minutes to plan, write and revise an essay about the topic below. Your response will be judged on how well you develop a position, organize your ideas, present supporting details, and control the elements of standard written English. You should write 200-300 words.";
      break;
    case 8:
      topbar = true;
      que = <SingleAnswer {...props} key={state.currentQuestion} />;
      title = "Read the text and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
      break;
    case 9:
      topbar = true;
      que = <MultipleAnswer {...props} key={state.currentQuestion} />;
      title = "Read the text and answer the question by selecting all the correct responses. More than one response is correct.";
      break;
    case 10:
      que = <Reorder {...props} key={state.currentQuestion} />;
      title = "The text boxes in the left panel have been placed in a random order. Restore the original order by dragging the text boxes from the left panel to the right panel.";
      break;
    case 11:
      topbar = true;
      que = <ReadingBlank {...props} option_explaination={state.option_explaination} quen={state.questionData[state.currentQuestion]} key={state.currentQuestion} />;
      title = "In the text below some words are missing. Drag words from the text box below to the appropriate place in the text. To undo an answer choice, drag the word back to the box below the text.";
      break;
    case 12:
      topbar = true;
      que = <WrittingBlank {...props} option_explaination={state.option_explaination} quen={state.questionData[state.currentQuestion]} key={state.currentQuestion} />;
      title = "Below is a text with blanks. Click on each blank, a list of choices will appear. Select the appropriate answer choice for each blank.";
      break;
    case 13:
      que = <Summer {...props} key={state.currentQuestion} />;
      title = "You will hear a short lecture. Write a summary for a fellow student who was not present at the lecture. You should write 50-70 words. You have 10 minutes to finish the task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the lecture.";
      break;
    case 14:
      topbar = true;
      que = <McqSingle {...props} key={state.currentQuestion} />;
      title = "Listen to the recording and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
      break;
    case 15:
      topbar = true;
      que = <McqMulti {...props} key={state.currentQuestion} />;
      title = "Listen to the recording and answer the question by selecting all the correct responses. You will need to select more than one response.";
      break;
    case 16:
      topbar = true;
      que = <ListeningBlank {...props} key={state.currentQuestion} />;
      title = "You will hear a recording. Type the missing words in each blank.";
      break;
    case 17:
      topbar = true;
      que = <CorrectSummary {...props} key={state.currentQuestion} />;
      title = "You will hear a recording. Click on the paragraph that best relates to the recording.";
      break;
    case 18:
      topbar = true;
      que = <MissingWord {...props} key={state.currentQuestion} />;
      title = "You will hear a recording about " + ques_title + ". At the end of the recording the last word or group of words has been replaced by a beep. Select the correct option to complete the recording";
      break;
    case 19:
      topbar = true;
      que = <Highlight {...props} key={state.currentQuestion} />;
      title = "You will hear a recording. Below is a transcription of the recording. Some words in the transcription differ from what the speaker(s) said. Please click on the words that are different.";
      break;
    case 20:
      que = <Dictation {...props} key={state.currentQuestion} />;
      title = "You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once.";
      break;
        case 22:
      que = <SummarizeGroupDiscussion {...props} key={state.currentQuestion} />;
      title =
        "You will hear three people having a discussion. When you hear the beep, summarize the whole discussion. You will have 10 seconds to prepare and 2 minutes to give your response.";
      break;
       case 21:
      que = <RespondToSituation {...props} key={state.currentQuestion} />;
      title =
        "Listen to and read a description of a situation. You will have 10 seconds to think about your answer. Then you will hear a beep. You will have 40 seconds to answer the question. Please answer as completely as you can.";
      break;
    default:
  }

  return (
    <>
      {!state.isLoaded ? (
        <><LaLoader show={!state.isLoaded} /></>
      ) : (
        <>
          {!state.unauthorized ? (
            <>
              {state.reportModal &&
                <Modal show={state.reportModal} centered size="lg">
                  <Modal.Body>
                    <Modal.Header className="p-0">
                      <div className="pb-2">
                      <div className="item-header">
                        <div className="item-title">
                          <span>Report the problem in this question</span>
                        </div>
                          <Button className="modalClose-Btn p-0 feedback-popup-close" onClick={reportModalfunc} aria-label="Close">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                            >
                              <path
                              d="M18 6L6 18M6 6l12 12"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              />
                            </svg>
                          </Button>
                      </div>
                    </div>
                       </Modal.Header>
                    <span className="text-danger">{state.reportErr}</span>
                    {/* <Input type="textarea" value={state.reportText} name="reportText" className="p-2" onChange={(e) => { changeReportText(e); }} /> */}
                    <InputGroup>
                      <Form.Control as="textarea" value={state.reportText} name="reportText" className="p-2" onChange={(e) => { changeReportText(e); }} />
                    </InputGroup>
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="btn-dark-custom" onClick={submitReport} disabled={state?.reportText === '' || state?.isSubmittingReport}>Submit</button>
                    {/* <Button color="secondary" id="feedback-btn" className="bottom-btn flex-grow-1 flex-sm-grow-0" onClick={reportModalfunc}>Close</Button> */}
                  </Modal.Footer>
                </Modal>
              }

              {/* {state.modal &&
                <Modal isOpen={state.modal} size="lg">
                  <div className="modalHeader">
                    <h2></h2>
                  </div>
                  <ModalBody>
                    <Table>
                      <thead>
                        <tr>
                          <th>Component</th>
                          <th>Score</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {showHistoryFunc().map((v) => {
                          return (ReactHtmlParser(v));
                        })}
                      </tbody>
                    </Table>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" className="modalCloseBtn" onClick={toggle}>Close</Button>
                  </ModalFooter>
                </Modal>
              } */}

              {state.modal &&
                <Modal
                  show={state.modal}
                  centered
                  size="lg"
                  className="performance-modal feedback-popup"
                >
                  <Modal.Header className="p-0">
                    <div className="performance-item">
                      <div className="item-header">
                        <div className="item-title">
                          <img src={BarFrequency} alt="BarFrequency" style={{maxHeight: "30px"}} />
                          <span>Detailed Performance Report</span>
                        </div>
                          <button variant="outline-primary" className="modalClose-Btn p-0 btn btn-link" onClick={toggle} aria-label="Close">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                            >
                              <path
                              d="M18 6L6 18M6 6l12 12"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              />
                            </svg>
                          </button>
                      </div>
                      <ul>
                        <li className="text-start mx-3" >In-depth breakdown of your evaluation</li>
                      </ul>
                    </div>
                  </Modal.Header>

                  <Modal.Body className="p-0">
                    <div className="performance-wrapper">
                    {showHistoryFunc1().map((v) => {
                          return (ReactHtmlParser(v));
                    })}
                  </div>
                  </Modal.Body>
                </Modal>
              }

              <DashboardHeader title="Result Feedback" />
               <div className="feedback-width">
                 <div className="pmw-outer-wrapper mt-2">
              <Row className="align-items-center align-items-md-start p-2">
                <Col xs={12} md={8} lg={9} xl={9} xxl={10}>
                  <div className="test-id mb-2">
                    <span className="d-block d-sm-inline">Test ID: #{id}</span>
                  </div>
                  <div>
                    <h4 className="mt-0 test-title">{state.mock_title}</h4>
                    <h6 className="test-description mb-2 mb-md-3 pb-md-1 fs-6 fs-md-5">{title}</h6>
                    <Row className='justify-content-end unselectable 4'>
                      {!state.pending && state.questionData && que}
                      {[21, 13, 19].includes(state.type) &&
                        <div className="mt-0">
                          <h3 className="fs-5 fs-md-4 mb-1">Question Script</h3>
                          <div className="fs-6 fs-md-5 reading-text">{ReactHtmlParser(val.question.audio_script)}</div>
                        </div>
                      }
                    </Row>
                  </div>
                </Col>
                <Col xs={12} md={4} lg={3} xl={3} xxl={2} className="mt-2 mt-md-0 d-flex justify-content-center">
                    <Score title="Overall Score" value={state.average_score} color="#B2EA47" />
                  {/* <div className="d-flex d-md-block justify-content-start">
                  </div> */}
                </Col>
              </Row>
              </div>

              <div className="my-2 mx-2 mx-sm-3 mx-md-4">
                <div className="row g-3 g-md-4">
                  {/* LEFT SECTION */}
                  <div className="col-12 col-lg-8">
                    <div className="card p-3 p-md-4 result-div old-design-result">
                      {[1, 2, 3, 4, 21, 22].includes(state.type) &&
                        <div className="mb-0 mt-3">
                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start mb-4">
                            <div className="d-flex gap-2 align-items-center mb-4 mb-md-0" >
                              <img src={Microphone} alt="Microphone" style={{maxHeight: "30px"}} />
                              <h3 className="mb-2 mb-md-0">Your Response Analysis</h3>
                            </div>
                            <div>
                              <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW d-flex flex-wrap gap-1 gap-md-2 justify-content-md-end">
                                <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                  <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>
                                  <span className="score-color" >Good</span>
                                </div>
                                <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                  <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJav"></div>
                                  <span className="score-color" >Average</span>
                                </div>
                                <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                  <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJbad"></div>
                                  <span className="score-color" >Bad pronunciation/Missed words</span>
                                </div>
                                
                              </div>
                               <div className="d-flex gap-2 align-items-center">
                                	{[1].includes(state.type) && (
                                            <>
                                            <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                              <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJshort"></div>
                                              Short pause
                                            </div>
                                            <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                              <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJlong"></div>
                                              Long pause
                                            </div>
                                            </>
                                          )}	
                                          </div>
                                </div>   
                            </div>
                          {/* </div> */}
                          {[3].includes(state.type) &&
                            <div className="d-flex mb-2">
                              <img
                                alt="media-link"
                                width="500"
                                src={`data:image/png;base64, ${props.data.image}`}
                              />
                            </div>                            
                          }
                          
                          <div className="my-4 text-start speak-words">{(val.html !== null) ? renderResponse(val.html) : ""}</div>
                          {![5].includes(state.type) && 
                          <div className="border-bottom-que my-4 " ></div>
                          }
                          {[2, 4, 5, 21, 22].includes(state.type) &&
                            <div>
                              <h6><span className="status-text">Question Audio</span></h6>
                              <div className="d-flex justify-content-between w-100 align-items-center">
                                <div className="my-4 mx-0 recording-section w-75">
                                  <WaveformAudioPlayer key={`question-${state.currentQuestion}-audio`} src={s3base + val.question.media_link + '?t=' + Date.now()} />
                                </div>
                              </div>
                            </div>
                          }
                          <h6 className="mb-2"><span className="status-text" >Your Response</span></h6>
                          <div className="d-flex justify-content-between w-100 align-items-center">
                              <div className="my-4 mx-0 recording-section w-75">
                            <WaveformAudioPlayer key={`response-${state.currentQuestion}-audio`} src={s3base + '/ptedata/ptemedia/' + val.file + '?t=' + Date.now()} />

                          </div>
                           	{(state.questionData[state.currentQuestion]?.speed_percentage && state.questionData[state.currentQuestion]?.speed_percentage !== null) && (
                               <div className="w-25">
                               <span className="">Speed</span>: <span className={state.questionData[state.currentQuestion].speed_percentage == "Too Slow" ? "color-danger" : (state.questionData[state.currentQuestion].speed_percentage == "Too Fast" ? "color-warning" : "color-success")}>{state.questionData[state.currentQuestion].speed_percentage}</span>
                               </div>
                            )}
                          </div>
                        </div>
                      }
                      {[15, 19, 14, 16, 18, 17, 13, 20].includes(state.type) &&
                            <div>
                              <h6><span className="status-text">Question Audio</span></h6>
                                <div className="d-flex justify-content-between w-100 align-items-center">
                                  <div className="my-4 mx-0 recording-section w-75">
                                  <WaveformAudioPlayer key={`question-${state.currentQuestion}-audio`} src={s3base + val.question.media_link + '?t=' + Date.now()} />
                                </div>
                              </div>
                            </div>
                      }
                      {[5].includes(state.type) &&
                        <div>
                          <div>
                            <h6><span className="status-text">Question Audio</span></h6>
                            <div className="d-flex justify-content-between w-100 align-items-center">
                                <div className="my-4 mx-0 recording-section w-75">
                                <WaveformAudioPlayer key={`question-${state.currentQuestion}-audio`} src={s3base + val.question.media_link + '?t=' + Date.now()}/>
                              </div>
                            </div>
                          </div>
                          <h3 className="fs-5 fs-md-4 mb-3">Your Response</h3>
                          <div className="d-flex justify-content-between w-100 align-items-center">
                                <div className="my-4 mx-0 recording-section w-75">
                                <WaveformAudioPlayer key={`response-${state.currentQuestion}-audio`} src={s3base + '/ptedata/ptemedia/' + val.file + '?t=' + Date.now()} />
                              </div>
                          </div>
                          {renderSimpleResponse(val.html)}
                          <div className="mt-3">
                            <h5 className="fs-6 fs-md-5">Correct answer: {val.question.answer}</h5>
                          </div>
                        </div>
                      }
                      
                      {[6, 7, 13].includes(state.type) && (
                        <div>
                          <h3 className="fs-5 fs-md-4 mb-3">Your Response Analysis</h3>
                          {state.questionData[state.currentQuestion]?.not_attempted !== 0 ? (
                            <div className="text-danger text-start fs-6 fs-md-5 mb-3">Not Attempted</div>
                          ) : (val.answer && stripHtml(val.answer).trim()) ? (
                            <div className="fs-6 fs-md-5 mb-3 text-start">{
                              // stripHtml(val.answer)
                              ReactHtmlParser(val.answer)
                              }</div>
                          ) : (
                            <div className="text-danger text-start fs-6 fs-md-5 mb-3">Not Answered</div>
                          )}
                          <div>
                            <h3 className="fs-6 fs-md-5">Word count: {val.correct}</h3>
                          </div>
                        </div>
                      )}

                      {[11, 12, 16].includes(state.type) && (
                        <div>
                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start mb-4">
                            <div className="d-flex gap-2 align-items-center mb-4 mb-md-0" >
                              {/* <img src={Microphone} alt="Microphone" style={{maxHeight: "30px"}} /> */}
                              <h3 className="mb-2 mb-md-0">Your Response Analysis</h3>
                            </div>
                            <div>
                              <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW d-flex flex-wrap gap-1 gap-md-2 justify-content-md-end">
                                <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                  <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>
                                  <span className="score-color" >Your selected & correct answer</span>
                                </div>
                                <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                  <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJavbl"></div>
                                  <span className="score-color" >Not selected & correct answer</span>
                                </div>
                                <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                  <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJbad"></div>
                                  <span className="score-color" >Your selected & wrong answer</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {(() => {
                            const notAttempted = state.questionData[state.currentQuestion]?.not_attempted !== 0;
                            // const hasAnswer = typeof val.answer === 'string' && val.answer.trim().length > 0;
                            const hasAnswer = typeof val?.answer === 'string' &&
        val.answer.split(',').some(v => {
          const t = v.trim();
          return t && t !== '-';
        });
                            if (notAttempted) {
                              return <div className="text-danger text-start fs-6 fs-md-5 mb-3">Not Attempted</div>;
                            }
                            if (!hasAnswer) {
                              return <div className="text-danger text-start fs-6 fs-md-5 mb-3">Not Answered</div>;
                            }
                            // const answerItems = val?.answer.split(',');
                            const selectedAnswer = state.questionData[state.currentQuestion].answer.split(",") || [];
                            let question = state.questionData[state.currentQuestion].question.question;
                            let correct = question.replace(/<[^>]*>?/gm, "x_x")
                                      .split("x_x").filter(function (i, x) {
                                        if (x % 2 != 0) return i;
                                      });
                            return (
                              <>
                              <div className="text-start" >
                                  {reactStringReplace(
                                    question,
                                    /__add_blank__<span id='cAns'>(.*?)<\/span>/g,
                                    (match,i) => {
                                      const answerIndex = (i - 1) / 2;

                                      const correctText = correct[answerIndex];
                                      const rawSelectedText = selectedAnswer?.[answerIndex];
                                      const selectedText = rawSelectedText?.trim();
                                      
                                      const isNotSelected = !selectedText || selectedText === "-";
                                      let isWrong = false;
                                      let isCorrect;
                                      if(selectedText){
                                        isCorrect = selectedText === correctText.trim() && selectedText !== "-";
                                        isWrong = selectedText && selectedText !== "-" && !isCorrect;                  
                                      }
                                        
                                      return (
                                        <span key={i} className="result-blank">
                                          {isCorrect && (
                                            <span className="pill pill-correct">
                                              {selectedText}
                                              <i className="fa fa-check icon-right" />
                                            </span>
                                          )}
                                          {isWrong && (
                                            <>
                                              <span className="pill pill-wrong">
                                                {selectedText}
                                                <i className="fa fa-times icon-right" />
                                              </span>
                                            {state.option_explaination.status && <i
                                                className="fa fa-question cursor-pointer blanks explanation-icon"
                                                onClick={() => {
                                                  setAnswerExplainationKey(correctText);
                                                  toggleModalExplanation();
                                                }}
                                              />}
                                            
                                            </>
                                          )}
                                          {isNotSelected && (
                                            <div className="d-flex">
                                            <span className="pill pill-missed">{correctText}</span>
                                            {state.option_explaination.status &&
                                            <i
                                                className="fa fa-question explanation-alert"
                                                onClick={() => {
                                                  setAnswerExplainationKey(correctText);
                                                  toggleModalExplanation();
                                                }}
                                            />
                                            }
                                            </div>
                                          )}
                                        </span>
                                      );
                                    }
                                  )}
                              </div>
                              {/* <div className="d-flex flex-wrap gap-1 gap-md-2">
                                {answerItems?.map((v, k, arr) => {
                                  if (
                                    k > val.correct.length &&
                                    v.trim() === val.correct.split(',')[k]?.trim()
                                  ) {
                                    return ReactHtmlParser(
                                      '<span class="d-inline-flex align-items-center">' +
                                      v +
                                      '<span class="ms-1"><i className="fa fa-check" style="font-size:24px;color:green"></i></span></span>'
                                    );
                                  } else {
                                    return ReactHtmlParser(
                                      '<span class="d-inline-flex align-items-center">' +
                                      v +
                                      '<span class="ms-1"><i className="fa fa-times" style="font-size:24px;color:red"></i></span></span>' + `${k !== arr.length - 1 ? ' , ' : ''}`
                                    );
                                  }
                                })}
                              </div> */}
                              </>
                            );
                          })()}
                        </div>
                      )}

                      {[19].includes(state.type) &&
                      <>
                      <div>
                        <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW d-flex flex-wrap gap-1 gap-md-2 justify-content-md-end">
                            <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                              <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>
                              <span className="score-color" >Your selected & correct answer</span>
                            </div>
                            <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                              <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJavbl"></div>
                              <span className="score-color" >Not selected & correct answer</span>
                            </div>
                            <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                              <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJbad"></div>
                              <span className="score-color" >Your selected & wrong answer</span>
                            </div>
                          </div>
                        </div>
                      <div>
                          <h3 className="fs-5 fs-md-4 mb-3">Your Response Analysis</h3>
                          {(state.questionData[state.currentQuestion]?.not_attempted !== 0) ? (
                            <div className="text-danger text-start fs-6 fs-md-5">Not Attempted</div>
                          ) : (val?.html) ?
                            <span className="result-correct"></span> : (
                              <div className="text-danger text-start fs-6 fs-md-5">Not Answered</div>
                            )
                          }
                        </div>
                      </>
                      }
{/*                       
                      {[20].includes(state.type) &&
                        <div>
                          <h3 className="fs-5 fs-md-4 mb-3">Correct Answer</h3>
                          <div className="text-success text-start fs-6 fs-md-5">{ReactHtmlParser(val.question.audio_script)}</div>
                        </div>
                      }
                       */}
                      {[8, 9, 14, 15, 17, 18].includes(state.type) &&
                        <div>
                          {/* <h3 className="fs-5 fs-md-4 mb-3">Your Response</h3> */}
                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start mb-4">
                            <div className="d-flex gap-2 align-items-center mb-4 mb-md-0" >
                              {/* <img src={Microphone} alt="Microphone" style={{maxHeight: "30px"}} /> */}
                              <h3 className="mb-2 mb-md-0">Your Response Analysis</h3>
                            </div>
                            <div>
                              <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW d-flex flex-wrap gap-1 gap-md-2 justify-content-md-end">
                                <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                  <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>
                                  <span className="score-color" >Your selected & correct answer</span>
                                </div>
                                <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                  <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJavbl"></div>
                                  <span className="score-color" >Not selected & correct answer</span>
                                </div>
                                <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                  <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJbad"></div>
                                  <span className="score-color" >Your selected & wrong answer</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* {(state.questionData[state.currentQuestion]?.not_attempted !== 0) ? (
                            <div className="text-danger text-start fs-6 fs-md-5">Not Attempted</div>
                          ) : (val?.html) ?
                            <div className="fs-6 text-start fs-md-5">{
                              // ReactHtmlParser(val.html)
                              <div className="answers">
                              {state.questionData[state.currentQuestion].question.option?.map(renderOption)}
                            </div>
                              }</div> : (
                              <div className="text-danger text-start fs-6 fs-md-5">Not Answered</div>
                            )
                          } */}
                          {(state.questionData[state.currentQuestion]?.not_attempted !== 0) ? (
      <div className="text-danger text-start fs-6 fs-md-5">Not Attempted</div>
    ) : (
      <div className="fs-6 text-start fs-md-5">
        <div className="answers">
          {state.questionData[state.currentQuestion].question.option?.map(renderOption)}
        </div>
      </div>
    )}
                        </div>
                      }
                      
                      {[20].includes(state.type) &&
                        <div>
                          <h3 className="fs-5 fs-md-4 mb-3">Your Response Analysis</h3>
                          {(state.questionData[state.currentQuestion]?.not_attempted !== 0) ? (
                            <div className="text-danger text-start fs-6 fs-md-5">Not Attempted</div>
                          ) : (val?.answer) ?
                            <div className="fs-6 text-start fs-md-5">{val?.answer}</div> : (
                              <div className="text-danger text-start fs-6 fs-md-5">Not Answered</div>
                            )
                          }
                        </div>
                      }
                      
                      {[10].includes(state.type) &&
                        <div className="row g-4">
                          <div className="col-12 col-md-6">
                            <h3 className="fs-5 fs-md-4 mb-3">Correct order</h3>
                            {/* {que} */}
                             {(() => {
                              let queData = state.questionData[state.currentQuestion];
                              const correctOrderIds = queData.correct.split(",").map(Number);
                              const orderedOptions = correctOrderIds
                              .map((id) => queData.question.option.find((opt) => opt.id === id)).filter(Boolean);

                              return orderedOptions.map((item, index) => (
                              <div key={item.id} className="correct-order-box">
                                <span>{item.options}</span>
                              </div>));
                              })()}
                          </div>
                          <div className="col-12 col-md-6">
                            <h3 className="fs-5 fs-md-4 mb-3">Your Response Analysis</h3>
                            <ul className="connectList list-unstyled">
                              {(state.questionData[state.currentQuestion]?.not_attempted !== 0) ?
                                <div className="text-danger text-start fs-6 fs-md-5">Not Attempted</div> :
                                (val.html) ?
                                  (val.html.split('<br />').filter((va) => { if (va !== "") { return va; } }).map((v, i) => {
                                    return ReactHtmlParser('<li class="list-group-item1 ' + getPairClass(i) + '">' + v + '</li>')
                                  }))
                                  :
                                  <div className="text-danger text-start fs-6 fs-md-5">Not Answered</div>
                              }
                            </ul>
                          </div>
                          {/* <div className="bottomBtn mt-4 mt-md-5">
                            {SHOW_SAMPLE_RESPONSE.includes(state.type) &&
                              <Row>
                                <MoreAiSuggestions
                                  question_id={state.questionData[state.currentQuestion].question.id}
                                />
                              </Row>
                            }
                          </div> */}
                        </div>
                      }
                      <div className="d-grid align-items-start mb-4">
                        <div className="d-flex gap-2 align-items-center mb-4 mb-md-0" >
                          <img src={TickCircle} alt="Tick Circle" style={{maxHeight: "30px"}} />
                          <h3 className="mb-2 mb-md-0">Performance Result</h3>
                        </div>
                        {/* <div className="d-flex gap-3 justify-content-start align-items-center">
                          {showScoreAnalysis().map((v) => {return (ReactHtmlParser(v));})}
                        </div> */}
                        <Row className="g-3">
                          {showScoreAnalysis().map((v, index) => (
                            <Col
                              key={index}
                              xs={6}      // Mobile → 2 per row
                              sm={4}      // Small tablet → 3 per row
                              md={3}      // Tablet → 4 per row
                              lg={4}      // Desktop → 6 per row
                              xl={3}
                              xxl={2}
                              className="d-flex"
                            >
                              {ReactHtmlParser(v)}
                            </Col>
                          ))}
                        </Row>
                      </div>
                      {SHOW_SAMPLE_RESPONSE.includes(state.type) &&
                        <Row>
                          <div className="bottomBtn gap-2 flex-column flex-md-row d-flex">
                            <MoreAiSuggestions
                              question_id={state.questionData[state.currentQuestion].question.id}
                            />
                          </div>
                        </Row>
                      }
                       <div className="d-flex gap-2 align-items-center">
                         <div className="w-fit-content text-center">
                          <button
                            className="btn-dark-custom w-100"
                            onClick={(e) => showScore(e, state.questionData.id)}
                          >
                            View Remarks
                          </button>
                        </div>
                        {
                          showParagraphExplanationButton() && (
                         <div className="w-fit-content text-center w-fit-content">
                          <button
                            className="btn-dark-custom w-100"
                            onClick={(e) => showExplanation()}
                          >
                          Full Paragraph Explanation
                          </button>
                        </div>
                          )
                        }
                        
                       </div>
                    </div>
                  </div>

                  {/* RIGHT SECTION */}
                  <div className="col-12 col-lg-4">
                    <div className="card p-3 p-md-4 h-auto h-lg-80 mb-3 mb-lg-0">
                      <h6 className="fw-bold mb-3 fs-6 fs-md-5">Question Palette</h6>
                      <div className="palette mb-4 d-flex flex-wrap gap-1 gap-md-2">
                        {state.questionData && state.questionData.map((v, k) => {
                          return <button
                            onClick={(e) => changeQuestion(e, k)}
                            className={(state.currentQuestion == k) ? 'palette-btn active cursor-pointer' : 'palette-btn cursor-pointer'}
                            key={k}
                          >
                            {(k + 1)}
                          </button>;
                        })}
                      </div>

                      <div className="d-flex flex-row justify-content-between mb-3 gap-2 gap-sm-0">
                        <Button
                          id="feedback-btn"
                          className="bottom-btn flex-grow-1 flex-sm-grow-0"
                          disabled={(state.currentQuestion == 0) && state.questionData.length !== 0}
                          color="primary"
                          onClick={prevButton}
                          size="lg"
                        >
                          Previous
                        </Button>
                        <Button
                          id="feedback-btn"
                          className="bottom-btn flex-grow-1 flex-sm-grow-0"
                          disabled={(state.questionData.length == (state.currentQuestion + 1)) && state.questionData.length !== 0}
                          color="primary"
                          onClick={nextButton}
                          size="lg"
                        >
                          Next
                        </Button>
                      </div>
                    </div>
                    
                    <div className="d-flex flex-row gap-4 mt-3">
                      {/* <button className="btn-dark-custom flex-grow-1" onClick={(e) => showScore(e, state.questionData.id)}>
                        View Remarks
                      </button> */}
                      <button className="btn-outline-custom flex-grow-1" onClick={reportModalfunc}>
                        Report Question
                      </button>
                    </div>
                  </div>
                </div>
              </div>

               </div>
              <div className="content questionsArea old-design d-none"> 
                <Row>
                  <Col xs={12}>
                    <Card>
                      {!state.pending &&
                        <Card.Body>
                          {topbar &&
                            <div className="row infoBars">
                              <div className="col-sm-3 wrongAns">
                                <i className="fa fa-times" aria-hidden="true"></i> <span>Your selected & wrong answer</span>
                              </div>
                              <div className="col-sm-3 correctAns">
                                <i className="fa fa-check" aria-hidden="true"></i> <span>Your selected & correct answer</span>
                              </div>
                              <div className="col-sm-3 notSelected">
                                <i className="fa fa-check" aria-hidden="true"></i> <span>Not selected & correct answer</span>
                              </div>
                            </div>
                          }

                          <div className="row">
                            <div className="col-sm-10">
                              <h4 className="mt-0">{state.mock_title}</h4>
                              <h6 style={{fontWeight: 500 , paddingBottom:"5px"}}>{title}</h6>
                              <hr />
                              <Row className='unselectable 5'>
                                {!state.pending && state.questionData && que}
                                {[13, 19].includes(state.type) &&
                                  <div>
                                    <h3>Audio Script</h3>
                                    <h4>{ReactHtmlParser(val.question.audio_script)}</h4>
                                  </div>
                                }
                              </Row>

                              <div className="result-div old-design-result">
                                {[2, 4, 5, 15, 19, 14, 16, 18, 17, 13, 20, 21, 22].includes(state.type) &&
                                  <div>
                                    <h3> Question Audio - </h3> <audio src={s3base + val.question.media_link} controls="controls" controlsList="nodownload" />
                                  </div>
                                }
                                {[6, 7, 13].includes(state.type) && (
                                      <div>
                                      <h3>Your Response</h3>
                                      {state.questionData[state.currentQuestion]?.not_attempted !== 0 ? (
                                      <h5 className="text-danger">Not Attempted</h5>
                                      ) : stripHtml(val.answer) ? (
                                      <h5>{stripHtml(val.answer)}</h5>
                                      ) : (
                                      <h5 className="text-danger">Not Answered</h5>
                                    )}
                                  <div>
                                  <h3>Word count: {val.correct}</h3>
                                  </div>
                                </div>
                                )}

                               {[11, 12, 16].includes(state.type) && (
                             <div>
                            {(() => {
                            const notAttempted =
                            state.questionData[state.currentQuestion]?.not_attempted !== 0;
                            console.log(state.questionData[state.currentQuestion]);
                            // const hasAnswer = typeof val.answer === 'string' && val.answer.trim().length > 0;
                            const hasAnswer = typeof val?.answer === 'string' &&
        val.answer.split(',').some(v => {
          const t = v.trim();
          return t && t !== '-';
        });
                            console.log("User answered : ",hasAnswer);
                            if (notAttempted) {
                           return <h5 className="text-danger">Not Attempted</h5>;
                           }

                           if (!hasAnswer) {
                           return <h5 className="text-danger">Not Answered</h5>;
                           }
                            const answerItems = val?.answer.split(',');
                         return answerItems?.map((v, k, arr) => {
                         if (
                         k >  val?.correct?.length &&
                       v.trim() === val.correct.split(',')[k]?.trim()
                        ) {
                      return ReactHtmlParser(
                        '<span>' +
                         v +
                        '<span><i className="fa fa-check" style="font-size:32px;color:green"></i></span></span>'
                        );
                      } else {
                      return ReactHtmlParser(
                     '<span>' +
                      v +
                      '<span><i className="fa fa-times" style="font-size:32px;color:red"></i></span></span>'+`${k !== arr.length - 1 ? ' , ' : '' }`
                     ); }
                     });
                    })()}
                     </div>
                                )}


                                {[19].includes(state.type) &&
                                  <div>
                                    <h3>Your Response</h3>
                                    {
                                      (state.questionData[state.currentQuestion]?.not_attempted !== 0) ? (
                                        <h5 className="text-danger">Not Attempted</h5>
                                      ) : (val?.html) ? 
                                        <span className="result-correct"></span> : (
                                        <h5 className="text-danger">Not Answered</h5>
                                      )
                                    }
                                  </div>
                                }
                                {[20].includes(state.type) &&
                                  <div>
                                    <h3>Correct Answer</h3>
                                    <h5 className="text-success">{ReactHtmlParser(val.question.audio_script)}</h5>
                                  </div>
                                }
                                {[8, 9, 14, 15, 17, 18].includes(state.type) &&
                                  <div>
                                    <h3>Your Response</h3>
                                      {
                                      (state.questionData[state.currentQuestion]?.not_attempted !== 0) ? (
                                     <h5 className="text-danger">Not Attempted</h5>
                                      ) : (val?.html) ? 
                                      <h5>{ReactHtmlParser(val.html)}</h5> : (
                                     <h5 className="text-danger">Not Answered</h5>
                                      )
                                    }
                                  </div>
                                }
                                {[20].includes(state.type) &&
                                  <div>
                                    <h3>Your Response</h3>
                                    {
                                      (state.questionData[state.currentQuestion]?.not_attempted !== 0) ? (
                                     <h5 className="text-danger">Not Attempted</h5>
                                      ) : (val?.answer) ? 
                                      <h5>{val?.answer}</h5> : (
                                     <h5 className="text-danger">Not Answered</h5>
                                      )
                                    }
                                    {/* <h5 className="text-danger">{((val.answer === null || val.answer !== null) && state.questionData[state.currentQuestion]?.not_attempted === 0) ? "-" : "(Not Attempted)"}</h5> */}
                                  </div>
                                }
                                {[10].includes(state.type) &&
                                  <div className="row">
                                    <div className="col-md-6">
                                      <h3>Correct order</h3>
                                      {que}
                                    </div>
                                    <div className="col-md-6">
                                      <h3>Your Response</h3>
                                      <div className="col-12"><h4 className="infoText"></h4></div><div className="col-12"><h5></h5></div><div className="col-12"><h3 className="question"></h3></div><div className="col-lg-12">&nbsp;</div><div className="col-lg-12"></div><div className="col-lg-12">&nbsp;</div>
                                      <ul className="connectList">
                                        {
                                           (state.questionData[state.currentQuestion]?.not_attempted !== 0) ? 
                                           <h5 className="text-danger">Not Attempted</h5> :
                                           (val.html) ?
                                            // (val.html.split('<br />').filter((va) => { if (va !== "") { return va; } }).map((v) => { return ReactHtmlParser('<li className="list-group-item1">' + v + '</li>') }))
                                            (val.html.split('<br />').filter((va) => { if (va !== "") { return va; } }).map((v, i) => { return ReactHtmlParser('<li class="list-group-item1 ' + getPairClass(i) + '">' + v + '</li>') }))
                                             :
                                           <h5 className="text-danger">Not Answered</h5>
                                         }

                                      </ul>
                                    </div>
                                  </div>
                                }
                                {[1, 2, 3, 4, 21, 22].includes(state.type) &&
                                  <div>
                                    <h3>Your Response</h3>
                                    <h5><audio src={s3base + '/ptedata/ptemedia/' + val.file} controls="controls"  crossOrigin = "anonymous" /></h5>
                                    <h5>{(val.html !== null) ? renderResponse(val.html) : ""}</h5>
                                    <div>
                                      <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW">
                                        <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                          <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>
                                          Good
                                        </div>
                                        <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                          <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJav"></div>
                                          Average
                                        </div>
                                        <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                          <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJbad"></div>
                                          Bad pronunciation/Missed words
                                        </div>
                                        <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca"></div>
                                      </div>
                                    </div>
                                  </div>
                                }
                                {/* {[3, 4, 21, 22].includes(state.type) &&
                                  <div>
                                    <h3>Your Response</h3>
                                    <h5><audio src={s3base + '/ptedata/ptemedia/' + val.file} controls="controls" /></h5>
                                    <h5>{(val.html !== null) ? renderResponse(val.html) : ""}</h5>
                                    <div>
                                      <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW">
                                        <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                          <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>Good
                                        </div>
                                        <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                          <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJav"></div>Average
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                } */}
                                {[5].includes(state.type) &&
                                  <div>
                                    <h3>Your Response</h3>
                                    <h5><audio src={s3base + '/ptedata/ptemedia/' + val.file} controls="controls" /></h5>
                                {renderSimpleResponse(val.html)}
                                <h5>Correct answer: {val.question.answer}</h5>
                                </div>
                                }

                                {/* {showParagraphExplanationButton() &&
                                  <div>
                                    <Button
                                      color="primary"
                                      className="viewResultbtn"
                                      onClick={(e) => showExplanation()}
                                      size="sm"
                                    >
                                      Full Paragraph Explanation
                                    </Button>
                                  </div>
                                } */}

                                {state.questionData &&
                                  <Button color="primary" className="viewResultbtn" onClick={(e) => showScore(e, state.questionData.id)} size="sm">View Score with Remarks</Button>
                                }
                              </div>
                              <div className="bottomBtn mt-5">
                                {SHOW_SAMPLE_RESPONSE.includes(state.type) &&
                                  <Row>
                                    <MoreAiSuggestions
                                      question_id={state.questionData[state.currentQuestion].question.id}
                                    />
                                  </Row>
                                }
                              </div>
                            </div>
                            <div className="col-sm-2 speakingBar p-0">
                              <h4><i className="" aria-hidden="true"></i></h4>
                              <div className="topArrow"></div>
                              <div className="numbersList unselectable 1">
                                {state.questionData && state.questionData.map((v, k) => {
                                  return <span onClick={(e) => changeQuestion(e, k)} className={(state.currentQuestion == k) ? 'selected-index-result cursor-pointer' : 'cursor-pointer'} key={k}>{(k + 1)}</span>;
                                })}
                              </div>
                              <div className="nextPrev unselectable 2">
                                {(state.currentQuestion !== 0) && state.questionData.length !== 0 &&
                                  <a onClick={prevButton} className="prev cursor-pointer"><i className="fa fa-chevron-circle-left" aria-hidden="true"></i> Prev </a>
                                }
                                {(state.questionData.length != (state.currentQuestion + 1)) && state.questionData.length !== 0 &&
                                  <a onClick={nextButton} className="next cursor-pointer">Next <i className="fa fa-chevron-circle-right" aria-hidden="true"></i></a>
                                }
                              </div>
                              <div className="quesStatus"></div>
                              <div className="bottomBtn text-center"></div>
                            </div>
                          </div>
                        </Card.Body>
                      }
                      {state.pending &&
                        <Card.Body>
                          <div className="scoreContent text-center">
                            <div className="scoreLoading">
                              <img src="https://gifimage.net/wp-content/uploads/2017/08/loading-gif-transparent-4.gif" />
                            </div>
                            <div className="scoreInfo">
                              <h4>AI Scoring Ongoing</h4>
                              <p>Takes around 5 - 10 minutes<br />You can check back later</p>
                            </div>
                          </div>
                        </Card.Body>
                      }
                    </Card>
                  </Col>

                  {state.paragraphExplainationModal &&
                    <FillInTheBlankExplanation
                      isOpen={state.paragraphExplainationModal}
                      title="Paragraph Explanation"
                      data={state.option_explaination ? state.option_explaination.paragraph_explanation : "Fetching Explanation..."}
                      keyName={'paragraph_explanation'}
                      closeModal={toggleModal}
                    />
                  }

                  {state.explanationModalWriting && (
                    <FillInTheBlankExplanation
                      isOpen={state.explanationModalWriting}
                      title={`${answer_explaination_key.charAt(0).toUpperCase()}${answer_explaination_key.slice(1)}`}
                      data={state.option_explaination}
                      keyName={answer_explaination_key}
                      closeModal={toggleModalExplanation}
                    />
                  )}

                  {!state.pending &&
                    <Col xs={12}>
                      <div className="mb-4">
                        {(state.questionData.length != (state.currentQuestion + 1)) && state.questionData.length !== 0 &&
                          <Button className="pull-right bottom-btn" id="feedback-btn" color="primary" onClick={nextButton} size="lg">NEXT</Button>
                        }
                        {(state.currentQuestion !== 0) && state.questionData.length !== 0 &&
                          <Button className="pull-right bottom-btn" id="feedback-btn" color="primary" onClick={prevButton} size="lg">PREVIOUS</Button>
                        }
                        {state.questionData.length !== 0 &&
                        <>
                          <Button
                            color="info"
                            id="feedback-btn"
                            className="bottom-btn"
                            onClick={reportModalfunc}
                            disabled={false}
                            size="lg"
                          >Report Question</Button>
                        </>
                        }
                      </div>
                    </Col>
                  }
                </Row>
              </div>
            </>) : <Unauthorized />
          }
        </>
      )}

      {state.explanationModal &&
        <TemplateDetectorModal
          isOpen={state.explanationModal}
          {...state.templateDetectorModalProps}
          data={state.templateDetectorModalProps.data}
          closeModal={closeModalExplanation}
        />
      }
    </>
  );
};


// const LegendDot = ({ color, label }) => (
//   <span className="me-3 d-inline-flex align-items-center gap-2">
//     <span
//       className="legend-dot"
//       style={{ background: color }}
//     />
//     {label}
//   </span>
// );
// d-grid d-md-flex
// col-12 col-md-9 align-items-center gap-3 score-card 
const Score = ({ title, value, color }) => (
  <div className="score-card d-flex flex-column flex-lg-row align-items-center gap-2 gap-lg-3">
    <div
      className="circle"
      style={{
        "--percent": value,
        "--color": color,
      }}
    >
      <div className="circle-inner">{value}</div>
    </div>
    <div className="score-label">{title}</div>
  </div>
);



export default Result;